import firebase, { database } from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import { getUsersByCompany } from './cacheService'
import { ensureReportAuth } from './core/reportAuth'
import { fetchTalentAndNetwork } from './core/talentAndNetwork'
import _ from 'lodash'
import format from 'date-fns/format'
import endOfMonth from "date-fns/end_of_month";
import addDays from 'date-fns/add_days';
import startOfWeek from 'date-fns/start_of_week'
import subMonths from 'date-fns/sub_months';
import subWeeks from 'date-fns/sub_weeks';
import startOfISOWeek from 'date-fns/start_of_iso_week'
import isFirstDayOfMonth from 'date-fns/is_first_day_of_month'
import parse from 'date-fns/parse'
import addMonths from 'date-fns/add_months';
import subQuarters from 'date-fns/sub_quarters';
import addYears from 'date-fns/add_years';
import startOfQuarter from 'date-fns/start_of_quarter';
// import question from './question'; // File removed!
//import axios from 'axios'
//const apiUrl = 'http://54.179.6.33:3000'
//const apiUrl = 'http://localhost:3000'
export default {
  namespaced: true,
  state: {
    user: '',
    team: '',
    engagement: {
      engagementKey: [],
      engagementType:'',
      challenges: {
        dailyCheck: "",
        peerFeedback: "",
        feedback: "",
        happilyVillage: "",
        superFeedback: "",
        rewards: "",
        recognition: "",
        favoritedSparks: "",
        superRecognition: "",
        NetworkBuilding: "",
      },
    },
    directReports: {
      engagedFocus: 0,
      engagedFocusType: "superEngaged",
      engagedValue: {
        superEngaged: 0,
        oldSuperEngaged: 0,
        highlyEngaged: 0,
        oldHighlyEngaged: 0,
        moderatelyEngaged: 0,
        oldModeratelyEngaged: 0,
        somewhatEngaged: 0,
        oldSomewhatEngaged: 0,
        notEngaged: 0,
        oldNotEngaged: 0,
      },
      engagedData: [],
    },
    directReportsLoading: true,
    directReportsEngagedValue: {
      superEngaged: 0,
      oldSuperEngaged: 0,
      highlyEngaged: 0,
      oldHighlyEngaged: 0,
      moderatelyEngaged: 0,
      oldModeratelyEngaged: 0,
      somewhatEngaged: 0,
      oldSomewhatEngaged: 0,
      notEngaged: 0,
      oldNotEngaged: 0,
    },
    directReportsEngagedData: [],
    directReports1: {},
    dailyContributions:'',
    youFeeling:[],
    teamFeeling:[],
    feeling:{good: 0,okay: 0,critical: 0},
    loading: true,
    userDetail:{},
    performingData:[],
    userCardData:{},
    directReportsCardData:[],
    growingData: {},
    loadingStatus: false,
    talentTeam:{},
    loadingProgress:0,
    holiday:[],
    dailyData:[],
    teamDailyData:[],
    alldays:false,
    month:[],
    consistent:'',
    companyCreatedate:''

  },
  mutations: {
    setTeam(state: any, result: any) {
      state.team = result
    },
    setEngagement(state: any, result: any) {
      state.engagement = result
    },
    setdirectReports(state: any, result: any) {
      state.directReports = result
    },
    setloading(state: any, result: any) {
      state.loading = result
    },
    setFeeling(state:any, result:any) {
      state.feeling = result
    },
    setPartTalentTeam(state:any, result:any) {
           
      state.directReportsCardData = result
  },
    setDirectReportsEngagedValue(state: any, result: any) {
      state.directReportsEngagedValue = result
    },
    setDirectReportsEngagedData(state: any, result: any) {
      state.directReportsEngagedData = result
    },
    setDirectReportsLoading(state: any, result: any) {
      state.directReportsLoading = result
    },
    setuserDetail(state: any, result: any) {
        state.userDetail = result
      },
    setContributions(state:any, result:any) {
        state.dailyContributions = result
    },
    setYouFeeling(state:any, result:any) {
      state.youFeeling = result
  },
  setTeamFeeling(state:any, result:any) {
    state.teamFeeling = result
  },
  setPerformingData(state:any, result:any) {
    state.performingData = result
  },
  setuserCardData(state: any, value: any) {
    state.userCardData = value
  },
  setGrowingData(state:any, result:any) {
    state.growingData = result
},
setTalentTeam(state:any, result:any) {
  state.talentTeam = result
},
setloadingStatus(state: any, value: any) {
  state.loadingStatus = value
},
setLoadingProgress(state: any, value: any) {
  state.loadingProgress = value
},
setdailyData(state: any, value: any) {
    state.dailyData = value
},
setConsistent(state: any, value: any) {
    state.consistent = value
},
setteamDailyData(state: any, value: any) {
    state.teamDailyData = value
}

  },
  actions: {

    async getTeam({ commit, dispatch, rootState, state ,getters}: any, value: any) {
      // getTeam ถูก dispatch จาก .vue — กัน race: ถ้า user ยังไม่พร้อม (ไม่มี company) ให้ข้าม
      // และ sign in ก่อนอ่าน /company (กัน permission_denied ถ้า session ยังไม่พร้อม)
      await ensureReportAuth()
      if (!value || !value.company) return
      const allUserKey ={}
      commit("setLoadingProgress",state.loadingProgress+10)
      const company = (await firebase.database().ref(`/company/${value.company}`).once('value')).val()

      state.companyCreatedate=company.createdate
      state.alldays=company.alldays?company.alldays:false
      const _usersByCompany = await getUsersByCompany(value.company)
      Object.values(_usersByCompany).forEach((childData:any) => {
            let _data = childData;
            const emailKey = _data.email.replace(/\./g, '||')
            if(rootState.quarterlyInsignhts.teamAll[_data.team]){

                    allUserKey[emailKey]=_data
            }
      })
      commit('setTeam', allUserKey)
      dispatch('getDailyData360',value)
      dispatch('getuserDetail',value)
      dispatch('getReportMonthly',value)
      
      
      
    },
    async getuserDetail({ commit, dispatch, rootState, state }: any, value: any){
      const quarter = '2025-Q3'//format(new Date(value.year, value.num_month, 1), "YYYY-Q")
      await firebase.firestore().collection('rel_map_hist_quarterly').doc(`${value.email}-${quarter}`).get().then((doc) => {
        if(doc.exists){
          const data = doc.data()
          if(data){
            let userDetail={
              totalConnections: data.node_count_total?data.node_count_total:0,
              innerNetwork:data.node_count_inner?data.node_count_inner:0,
              newInnerNetwork: data.node_new_inner?data.node_new_inner:0,
              outerNetwork: data.node_count_outer?data.node_count_outer:0,
              newOuterNetwork: data.node_new_outer?data.node_new_outer:0,
          }
          //console.log("userDetail",userDetail);
        commit('setuserDetail',userDetail)
          }
          //console.log("data",data);
        }
      })




            
      let pastMonth = value.num_month - 1;
      let year = parseInt(format(value.year, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
      var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
      var talentTeam={}
      fetchTalentAndNetwork({
        date: value.year+'-'+value.num_month+'-'+lastDayOfMonth,
        company: value.company,
        email: value.email,
      })
      .then(function (response) {
        const data = response.data
         // console.log("data",JSON.stringify(response.data));
              //   let userDetail={
              //     totalConnections: data.network?data.network.node_count_total:0,
              //     innerNetwork:data.network?data.network.node_count_inner:0,
              //     newInnerNetwork: data.network?data.network.node_new_inner:0,
              //     outerNetwork: data.network?data.network.node_count_outer:0,
              //     newOuterNetwork: data.network?data.network.node_new_outer:0,
              // }
          data.talent.map(value=>{
            const emailKey = value.email.replace(/\./g, '||')
            talentTeam[emailKey]=value.talent_before
          })
          commit('setTalentTeam',talentTeam)
          //commit('setuserDetail',userDetail)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
    getReportMonthly({ commit, dispatch, rootState, state }: any, value: any){
      commit("setloadingStatus",true)
      commit("setLoadingProgress",state.loadingProgress+15)

    var _directReports= {
        engagedFocus: 0,
        engagedFocusType: "highlyEngaged",
        engagedValue: {
          // superEngaged: 0,
          // oldSuperEngaged: 0,
          highlyEngaged: 0,
          oldHighlyEngaged: 0,
          moderatelyEngaged: 0,
          oldModeratelyEngaged: 0,
          somewhatEngaged: 0,
          oldSomewhatEngaged: 0,
          notEngaged: 0,
          oldNotEngaged: 0,
          inActive:0,
          oldInActive:0
        },
        engagedData: [],
      }
    
    commit("setdirectReports",_directReports)
      let performingData:Array<any>=[]
      var PersonalGrowth:any={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Recognition:any={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Rel_Colleagues:any={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Satisfaction:any={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Ambassadorship:any={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Feedback:any={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Wellness:any={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Company_Alignment:any={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Rel_Manager:any={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      let month = parseInt(value.num_month);
 
      let pastMonth = month - 1;

      let year = parseInt(format(value.year, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
      var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
      
      var status_feeling={good: 0,okay: 0,critical: 0}
      let start_date = value.year + "-" + value.num_month 
      let lastDate=value.year + "-" + value.num_month+"-"+"31" 
      let feeling: Array<any>=[];
      let end_date  = format(subMonths(start_date, 1), 'YYYY-MM')
      start_date='2025-07'
      lastDate='2025-09-31'
      let past_quarter_date=format(subQuarters(start_date, 1), 'YYYY-MM')
      let past_quarter=format(subQuarters(start_date, 1), 'YYYY-Q')
     //console.log('past_quarter_date=======>',past_quarter_date)
      const quarter_date:any=[]
      let day_quarter=0
      for(let i=0;i<3;i++){
        const endOfMonthDate=endOfMonth(new Date(addMonths(start_date, i)))
        day_quarter+=parseInt(format(endOfMonthDate, "D"))
        quarter_date.push(format(new Date(addMonths(past_quarter_date, i)), "YYYY-MM"))
        quarter_date.push(format(new Date(addMonths(start_date, i)), "YYYY-MM"))
      }
     // console.log('quarter_date=======>',quarter_date)
      // console.log('day_quarter=======>',day_quarter)

      let OldtalentTeam=state.talentTeam
      var _engagement={}
      var userEngagementData:any={}
      let engagedData : Array<any> = [];
      var data_Contribution={}
      let engagement={
        challenges: {
          dailyCheck: "",
          peerFeedback: "",
          feedback: "",
          happilyVillage: "",
          superFeedback: "",
          rewards: "",
          recognition: "",
          favoritedSparks: "",
          superRecognition: "",
          NetworkBuilding: "",
        },
      }
      let directReports: Array<any>=[
        {name: "Untapped Potential",value: 0},
        {name: "Activated",value: 0},
        {name: "High Performer",value: 0},
        {name: "Superstar",value: 0},

        {name: "Valued Contributor",value: 0},
        {name: "Key Player",value: 0},
        {name: "Respected Expert",value: 0},
        {name: "Distinguished Talent",value: 0},

        {name: "Community Pillar",value: 0},
        {name: "Engaged Contributor",value: 0},
        {name: "Core Player",value: 0},
        {name: "Solid Performer",value: 0},

        {name: "Up-and-Coming",value: 0},
        {name: "Rising Star",value: 0},
        {name: "Emerging Talent",value: 0},
        {name: "High Potential",value: 0},

        {name: "Latent Potential",value: 0},
        {name: "Contributor",value: 0},
        {name: "Crowd Favorite",value: 0},
        {name: "Unsung Talent",value: 0},
        // {name: "Untapped Potential",value: 0},
        // {name: "Activated",value: 0},
        // {name: "High Performer",value: 0},
        // {name: "Superstar",value: 0},
        // {name: "Community Pillar",value: 0},
        // {name: "Engaged Contributor",value: 0}, 
        // {name: "Core Player",value: 0},
        // {name: "Solid Performer",value: 0},
        // {name: "Up-and-coming", value: 0},
        // {name: "Rising Star",value: 0},
        // {name: "Emerging Talent",value: 0},
        // {name: "High Potential",value: 0},
        // {name: "Latent Potential",value: 0},
        // {name: "Contributor",value: 0},
        // {name: "Crowd Favorite",value: 0},
        // {name: "Unsung Talent",value: 0},
      ]
      const allUserKey = state.team
      let growingTeam: Array<any> = [];
      let holiday: Array<any> = [];
      let youFeeling: Array<any>=[];
      let team: { [key: string]: any } = {};
      let _team: Array<any> = [];
      let userCardData: any = {};
      let talentClass: any = '';
      let networkClass: any = '';
      let trulyClass: any = '';
      let starClass: any = '';
      let engagementClass: any = ''; 
      let checkPeople=true
      let talentTeam: { [key: string]: any } = {};
      let users_sleep_steps: { [key: string]: any } = {};
      const skillMaster={      
        "ps_leadership":'l',
        "ps_self_awareness":'s',
        "ps_optimism":'o',
        "ps_critical_thinking":'c',
        "ps_empathy":'e',
        "ps_initiative_making":'i'
      }
      const thisQuarter=format(new Date(start_date), "YYYY-Q")
      //console.log('thisQuarter=======>',thisQuarter)

        firebase.database().ref('team').once('value', (snapshot) => {
          snapshot.forEach((childSnapshot) => {
              let _data = childSnapshot.val();
              _team.push({..._data,key:childSnapshot.key})
              
          })
          team= _.groupBy(_team, function (b) { return b.key })
        
        })
        firebase.firestore().collection('/holliday').where('companyid','==',value.company).where('date','>=',`${start_date}-01`).where('date','<=',lastDate).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              holiday.push(data)        
          })
       
      })
      firebase.firestore().collection('users_sleep_steps').where('email', '==', value.email).where('date','>=',`${start_date}-01`).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            const data = doc.data()
            if(!users_sleep_steps[data.date]){
              users_sleep_steps[data.date]={steps:data.steps,sleep:data.sleep}
            }
        })
      })


    const quarterData:any={}
    const pastQuarterData:any={}
  
        firebase.firestore().collection('report_monthly').where('company', '==', value.company).where("monthyear", "in", quarter_date).get().then( async (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          //const emailKey = data.email.replace(/\./g, '||')
          
          if(!_engagement[data.email+"-"+data.monthyear]){
            _engagement[data.email+"-"+data.monthyear]={}
          }
          _engagement[data.email+"-"+data.monthyear]=data

          const quarter=format(data.monthyear, "YYYY-Q")
          if(quarter===thisQuarter){

            


            if(!quarterData[data.email+"-"+quarter]){
              quarterData[data.email+"-"+quarter]={
                daily:0,
                feedback:0,
                replyrate:0,
                insight:0,
                recognition:0,
                peerfeedback:0,
                feedback_all:0,
                feedback_rate:0,
                super_feedback:0,
                super_recognition:0,
                happily_village:0,
                report_card_good:0,
                report_card_notgood:[],
                daily_answer:[],
                dimensions:{
                  PersonalGrowth:{total:0,value:0},
                  Recognition:{total:0,value:0},
                  Rel_Colleagues:{total:0,value:0},
                  Satisfaction:{total:0,value:0},
                  Ambassadorship:{total:0,value:0},
                  Feedback:{total:0,value:0},
                  Rel_Manager:{total:0,value:0},
                  Wellness:{total:0,value:0},
                  Company_Alignment:{total:0,value:0},
                }
                
              }
            }
  
  
            quarterData[data.email+"-"+quarter].report_card_good+=data.report_card_good?data.report_card_good:0
            if(data.report_card_notgood){
              _.forEach(data.report_card_notgood, (value) => {
                quarterData[data.email+"-"+quarter].report_card_notgood.push(value)
              })
            }
            quarterData[data.email+"-"+quarter].daily+=data.daily?data.daily:0
            
            if(data.replyrate!=='-'){
              quarterData[data.email+"-"+quarter].replyrate+=data.replyrate?data.replyrate:0
            }
            if(data.daily_answer){
              _.forEach(data.daily_answer, (value) => {
                quarterData[data.email+"-"+quarter].daily_answer.push(value)
              })
            }
            quarterData[data.email+"-"+quarter].insight+=data.insight?data.insight:0
            quarterData[data.email+"-"+quarter].recognition+=data.recognition?data.recognition:0
            quarterData[data.email+"-"+quarter].peerfeedback+=data.peerfeedback?data.peerfeedback:0
            quarterData[data.email+"-"+quarter].super_feedback+=data.super_feedback?data.super_feedback:0
            quarterData[data.email+"-"+quarter].super_recognition+=data.super_recognition?data.super_recognition:0
            quarterData[data.email+"-"+quarter].happily_village+=data.happilycount?data.happilycount:0
  
            quarterData[data.email+"-"+quarter].feedback+=data.feedback?data.feedback:0
            quarterData[data.email+"-"+quarter].feedback_all+=data.feedback_all?data.feedback_all:0

            quarterData[data.email+"-"+quarter].feedback_rate+=Number(data.feedback_all)>0?isNaN(Number(data.feedback)/Number(data.feedback_all))?0:(Number(data.feedback)/Number(data.feedback_all)):0



            quarterData[data.email+"-"+quarter].dimensions.PersonalGrowth.value+=data.dimensions&&data.dimensions.PersonalGrowth?data.dimensions.PersonalGrowth.value:0
            quarterData[data.email+"-"+quarter].dimensions.PersonalGrowth.total+=data.dimensions&&data.dimensions.PersonalGrowth?data.dimensions.PersonalGrowth.total:0
            quarterData[data.email+"-"+quarter].dimensions.Recognition.value+=data.dimensions&&data.dimensions.Recognition?data.dimensions.Recognition.value:0
            quarterData[data.email+"-"+quarter].dimensions.Recognition.total+=data.dimensions&&data.dimensions.Recognition?data.dimensions.Recognition.total:0
            quarterData[data.email+"-"+quarter].dimensions.Rel_Colleagues.value+=data.dimensions&&data.dimensions.Rel_Colleagues?data.dimensions.Rel_Colleagues.value:0
            quarterData[data.email+"-"+quarter].dimensions.Rel_Colleagues.total+=data.dimensions&&data.dimensions.Rel_Colleagues?data.dimensions.Rel_Colleagues.total:0
            quarterData[data.email+"-"+quarter].dimensions.Satisfaction.value+=data.dimensions&&data.dimensions.Satisfaction?data.dimensions.Satisfaction.value:0
            quarterData[data.email+"-"+quarter].dimensions.Satisfaction.total+=data.dimensions&&data.dimensions.Satisfaction?data.dimensions.Satisfaction.total:0
            quarterData[data.email+"-"+quarter].dimensions.Ambassadorship.value+=data.dimensions&&data.dimensions.Ambassadorship?data.dimensions.Ambassadorship.value:0
            quarterData[data.email+"-"+quarter].dimensions.Ambassadorship.total+=data.dimensions&&data.dimensions.Ambassadorship?data.dimensions.Ambassadorship.total:0
            quarterData[data.email+"-"+quarter].dimensions.Feedback.value+=data.dimensions&&data.dimensions.Feedback?data.dimensions.Feedback.value:0
            quarterData[data.email+"-"+quarter].dimensions.Feedback.total+=data.dimensions&&data.dimensions.Feedback?data.dimensions.Feedback.total:0
            quarterData[data.email+"-"+quarter].dimensions.Rel_Manager.value+=data.dimensions&&data.dimensions.Rel_Manager?data.dimensions.Rel_Manager.value:0
            quarterData[data.email+"-"+quarter].dimensions.Rel_Manager.total+=data.dimensions&&data.dimensions.Rel_Manager?data.dimensions.Rel_Manager.total:0
            quarterData[data.email+"-"+quarter].dimensions.Wellness.value+=data.dimensions&&data.dimensions.Wellness?data.dimensions.Wellness.value:0
            quarterData[data.email+"-"+quarter].dimensions.Wellness.total+=data.dimensions&&data.dimensions.Wellness?data.dimensions.Wellness.total:0
            quarterData[data.email+"-"+quarter].dimensions.Company_Alignment.value+=data.dimensions&&data.dimensions.Company_Alignment?data.dimensions.Company_Alignment.value:0
            quarterData[data.email+"-"+quarter].dimensions.Company_Alignment.total+=data.dimensions&&data.dimensions.Company_Alignment?data.dimensions.Company_Alignment.total:0  

          }else{

            if(!pastQuarterData[data.email+"-"+quarter]){
              pastQuarterData[data.email+"-"+quarter]={
                daily:0,
                feedback:0,
                replyrate:0,
                insight:0,
                recognition:0,
                peerfeedback:0,
                feedback_all:0,
                dimensions:{
                  PersonalGrowth:{total:0,value:0},
                  Recognition:{total:0,value:0},
                  Rel_Colleagues:{total:0,value:0},
                  Satisfaction:{total:0,value:0},
                  Ambassadorship:{total:0,value:0},
                  Feedback:{total:0,value:0},
                  Rel_Manager:{total:0,value:0},
                  Wellness:{total:0,value:0},
                  Company_Alignment:{total:0,value:0},
                },
                super_feedback:0,
                super_recognition:0,
                happily_village:0,
                daily_answer:[]
              }
            }


            pastQuarterData[data.email+"-"+quarter].daily+=data.daily?data.daily:0
            pastQuarterData[data.email+"-"+quarter].feedback+=data.feedback?data.feedback:0
            if(data.daily_answer){
              _.forEach(data.daily_answer, (value) => {
                pastQuarterData[data.email+"-"+quarter].daily_answer.push(value)
              })
            }
            if(data.replyrate!=='-'){
              pastQuarterData[data.email+"-"+quarter].replyrate+=data.replyrate?data.replyrate:0
            }
            
            pastQuarterData[data.email+"-"+quarter].insight+=data.insight?data.insight:0
            pastQuarterData[data.email+"-"+quarter].recognition+=data.recognition?data.recognition:0
            pastQuarterData[data.email+"-"+quarter].peerfeedback+=data.peerfeedback?data.peerfeedback:0

            pastQuarterData[data.email+"-"+quarter].super_feedback+=data.super_feedback?data.super_feedback:0
            pastQuarterData[data.email+"-"+quarter].super_recognition+=data.super_recognition?data.super_recognition:0
            pastQuarterData[data.email+"-"+quarter].happily_village+=data.happilycount?data.happilycount:0
  
  
            pastQuarterData[data.email+"-"+quarter].feedback+=data.feedback?data.feedback:0
            pastQuarterData[data.email+"-"+quarter].feedback_all+=data.feedback_all?data.feedback_all:0
  
            pastQuarterData[data.email+"-"+quarter].dimensions.PersonalGrowth.value+=data.dimensions&&data.dimensions.PersonalGrowth?data.dimensions.PersonalGrowth.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.PersonalGrowth.total+=data.dimensions&&data.dimensions.PersonalGrowth?data.dimensions.PersonalGrowth.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Recognition.value+=data.dimensions&&data.dimensions.Recognition?data.dimensions.Recognition.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Recognition.total+=data.dimensions&&data.dimensions.Recognition?data.dimensions.Recognition.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Rel_Colleagues.value+=data.dimensions&&data.dimensions.Rel_Colleagues?data.dimensions.Rel_Colleagues.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Rel_Colleagues.total+=data.dimensions&&data.dimensions.Rel_Colleagues?data.dimensions.Rel_Colleagues.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Satisfaction.value+=data.dimensions&&data.dimensions.Satisfaction?data.dimensions.Satisfaction.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Satisfaction.total+=data.dimensions&&data.dimensions.Satisfaction?data.dimensions.Satisfaction.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Ambassadorship.value+=data.dimensions&&data.dimensions.Ambassadorship?data.dimensions.Ambassadorship.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Ambassadorship.total+=data.dimensions&&data.dimensions.Ambassadorship?data.dimensions.Ambassadorship.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Feedback.value+=data.dimensions&&data.dimensions.Feedback?data.dimensions.Feedback.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Feedback.total+=data.dimensions&&data.dimensions.Feedback?data.dimensions.Feedback.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Rel_Manager.value+=data.dimensions&&data.dimensions.Rel_Manager?data.dimensions.Rel_Manager.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Rel_Manager.total+=data.dimensions&&data.dimensions.Rel_Manager?data.dimensions.Rel_Manager.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Wellness.value+=data.dimensions&&data.dimensions.Wellness?data.dimensions.Wellness.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Wellness.total+=data.dimensions&&data.dimensions.Wellness?data.dimensions.Wellness.total:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Company_Alignment.value+=data.dimensions&&data.dimensions.Company_Alignment?data.dimensions.Company_Alignment.value:0
            pastQuarterData[data.email+"-"+quarter].dimensions.Company_Alignment.total+=data.dimensions&&data.dimensions.Company_Alignment?data.dimensions.Company_Alignment.total:0  





          }
          

        })
       
        commit("setLoadingProgress",state.loadingProgress+15)

        for (const user in allUserKey) {
         
          let engagementKey: Array<any> = []
          let engagedType: string = ''
          let engagedSort=0

          var result:Array<any>=[]
          let medalCount:any=0
          if(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].medal){
            _.forEach(_engagement[allUserKey[user].email+"-"+start_date].medal, (value,key)=> { 
              medalCount += value
            });
          }
          
          if(_engagement[allUserKey[user].email+"-"+start_date]!==undefined){
          for (const excel in _engagement[allUserKey[user].email+"-"+start_date].excels) {
            let data={name:excel,value:_engagement[allUserKey[user].email+"-"+start_date].excels[excel]}
            result.push(data)
          }
          }

          if(talentTeam[allUserKey[user].talent]!=undefined)
          {
              talentTeam[allUserKey[user].talent]++
          }else {
              talentTeam[allUserKey[user].talent]=1
          }







          // if(_engagement[allUserKey[user].email+"-"+start_date]){
    
          //   if(!_engagement[allUserKey[user].email+"-"+start_date].daily_answer){
          //     engagedType = "inActive"
          //     engagedSort=6
          //     state.directReports.engagedValue.inActive++
          //     engagementClass='a'
          //   }else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].feedback_color === 'green' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color !== 'red' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].recognition_color === 'green' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color !== 'red' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].happily_village_color !== 'red' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color === 'green' ) {
          //     engagedType = "highlyEngaged"
          //     engagedSort=2
          //     engagementClass='d'
          //     state.directReports.engagedValue.highlyEngaged++

          //   } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].feedback_color !== 'red' &&
          //     _engagement[allUserKey[user].email+"-"+start_date].recognition_color !== 'red') {
          //     engagedType = "moderatelyEngaged"
          //     engagedSort=3
          //     state.directReports.engagedValue.moderatelyEngaged++
          //     engagementClass='c'
          //   } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color !== 'red') {
          //     engagedType = "somewhatEngaged"
          //     engagedSort=4
          //     engagementClass='b'
          //     state.directReports.engagedValue.somewhatEngaged++

          //   } else {
          //     engagedType = "underEngaged"
          //     engagedSort=5
          //     engagementClass='a'
          //     state.directReports.engagedValue.notEngaged++

          //   }
          // }
    

        //   if(_engagement[allUserKey[user].email+"-"+end_date]){
        //   //======old=======
        // if(!_engagement[allUserKey[user].email+"-"+end_date].daily_answer){
        
        //   state.directReports.engagedValue.oldInActive++
        // }
        // else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].feedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].super_feedback_color !== 'red' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].recognition_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].super_recognition_color !== 'red' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].happily_village_color !== 'red' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].peerfeedback_color === 'green' ) {
          
        //   state.directReports.engagedValue.oldHighlyEngaged++
            

        // } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].feedback_color !== 'red' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].recognition_color !== 'red' ) {
            
        //   state.directReports.engagedValue.oldModeratelyEngaged++
            

        // } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color !== 'red') {
        
        //   state.directReports.engagedValue.oldSomewhatEngaged++
          
        // } else {
        
        //   state.directReports.engagedValue.oldNotEngaged++
          

        // }
        //   }
    
          var networkbulding_color=""
          if((state.userDetail.newInnerNetwork+state.userDetail.newOuterNetwork)>0){
            networkbulding_color="green"
          }
          else{
            networkbulding_color="red"
          }


          
          let super_feedback_color = 'red';
          let super_recognition_color = 'red';
          let happily_village_color = 'red';
          let insight_color = 'red';
          let replyrate_color = 'red';
          let daily_color = 'red';
          let open_ended_color = 'red';
          let recognition_color = 'red';
          let peerfeedback_color = 'red';
          if(quarterData[allUserKey[user].email+"-"+thisQuarter]){

          let super_feedback = 0;
          super_feedback = isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].super_feedback)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].super_feedback/3)
          if(super_feedback > 50){
            super_feedback_color = 'green';
          }else if(super_feedback >= 25){
            super_feedback_color = 'yellow';
          }

          
          let super_recognition = isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].super_recognition)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].super_recognition/3)
          if(super_recognition >= 50){
            super_recognition_color = 'green';
          }else if(super_recognition >= 25){
            super_recognition_color = 'yellow';
          }

         
          let happily_village = isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].happily_village)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].happily_village/3)
          if (happily_village >= 5) {
            happily_village_color = 'green';
          } else if (happily_village >= 1) {
            happily_village_color = 'yellow';
          } 
        





          const insight=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].insight)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].insight/3)
      
          if (insight >= 0.75){
            insight_color = 'green';
          }else if (insight >= 0.40){
            insight_color = 'yellow';
          }
          const replyrate=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].replyrate)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].replyrate/3)
          
          if (replyrate >= 0.6) {
            replyrate_color = 'green';
          } else if (replyrate >= 0.30) {
            replyrate_color = 'yellow';
          }
          const peerfeedback=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].peerfeedback)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].peerfeedback/3)

          const daily=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].daily)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].daily/3)
          

          if (daily >= 0.75) {
              daily_color = 'green';
            } else if (daily >= 0.50) {
              daily_color = 'yellow';
            }
            
            // const number_of_open_ended=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback/3)
            // const number_of_feedback_all=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback_all)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback_all/3)
          const number_of_feedback_rate=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback_rate)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback_rate/3)
          // console.log("feedback_rate",quarterData[allUserKey[user].email+"-"+thisQuarter].feedback_rate);
          // console.log("number_of_feedback_rate",number_of_feedback_rate);
          if(number_of_feedback_rate >= 0.75){
              open_ended_color = 'green';
          }else if(number_of_feedback_rate >= 0.40){
              open_ended_color = 'yellow';
          }

          const recognition=isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].recognition)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].recognition/3)

          
          if (recognition >= 0.5) {
              recognition_color = 'green';
          } else if (recognition >= 0.25) {
              recognition_color = 'yellow';
          }


          peerfeedback_color=(peerfeedback >= 1)?'green':'red'



        






          if(!quarterData[allUserKey[user].email+"-"+thisQuarter].daily_answer){
            engagedType = "inActive"
            engagedSort=6
            state.directReports.engagedValue.inActive++
            engagementClass='a'
          }else if(daily_color === 'green' && 
            open_ended_color === 'green' && 
            super_feedback_color !== 'red' && 
            recognition_color === 'green' && 
            super_recognition_color !== 'red' &&
            happily_village_color !== 'red' && 
            peerfeedback_color === 'green'){
            engagedType = "highlyEngaged"
            engagedSort=2
            engagementClass='d'
            state.directReports.engagedValue.highlyEngaged++

          }else if(daily_color === 'green' && 
            open_ended_color !== 'red' && 
            recognition_color !== 'red'){
            engagedType = "moderatelyEngaged"
            engagedSort=3
            state.directReports.engagedValue.moderatelyEngaged++
            engagementClass='c'

          }else if(daily_color !== 'red'){
            engagedType = "somewhatEngaged"
            engagedSort=4
            state.directReports.engagedValue.somewhatEngaged++
            engagementClass='b'
          }else{
            engagedType = "underEngaged"
            engagedSort=5
            state.directReports.engagedValue.notEngaged++
            engagementClass='a'
          }
          }else{
            engagedType = "inActive"
            engagedSort=6
            state.directReports.engagedValue.inActive++
            engagementClass='a'
          }




           //=====past quarter=====  

           if(pastQuarterData[allUserKey[user].email+"-"+past_quarter]){
                let past_super_feedback = 0;
                let past_super_feedback_color = 'red';
                past_super_feedback = isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].super_feedback)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].super_feedback/3)
                if(past_super_feedback > 50){
                  past_super_feedback_color = 'green';
                }else if(past_super_feedback >= 25){
                  past_super_feedback_color = 'yellow';
                }

                let past_super_recognition_color = 'red';
                let past_super_recognition = isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].super_recognition)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].super_recognition/3)
                if(past_super_recognition >= 50){
                  past_super_recognition_color = 'green';
                }else if(past_super_recognition >= 25){
                  past_super_recognition_color = 'yellow';
                }


                let past_happily_village_color = 'red';
                let past_happily_village = isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].happily_village)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].happily_village/3)
                if (past_happily_village >= 5) {
                  past_happily_village_color = 'green';
                } else if (past_happily_village >= 1) {
                  past_happily_village_color = 'yellow';
                } 


                const past_peerfeedback=isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].peerfeedback)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].peerfeedback/3)

                const past_daily=isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].daily)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].daily/3)
                let past_daily_color = 'red';

                if (past_daily >= 0.75) {
                    past_daily_color = 'green';
                  } else if (past_daily >= 0.50) {
                    past_daily_color = 'yellow';
                  }
                  let past_open_ended_color = 'red';
                  const past_number_of_open_ended=isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].open_ended)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].open_ended/3)
                  if(past_number_of_open_ended >= 0.75){
                      past_open_ended_color = 'green';
                  }else if(past_number_of_open_ended >= 0.40){
                      past_open_ended_color = 'yellow';
                  }

                  const past_recognition=isNaN(pastQuarterData[allUserKey[user].email+"-"+past_quarter].recognition)?0:(pastQuarterData[allUserKey[user].email+"-"+past_quarter].recognition/3)

                  let past_recognition_color = 'red';
                  if (past_recognition >= 0.5) {
                      past_recognition_color = 'green';
                  } else if (past_recognition >= 0.25) {
                      past_recognition_color = 'yellow';
                  }


                  const past_peerfeedback_color=(past_peerfeedback >= 1)?'green':'red'

    



          



            
          
                  //======old=======
                if(!pastQuarterData[allUserKey[user].email+"-"+past_quarter].daily_answer){
                
                  state.directReports.engagedValue.oldInActive++
                }
                else if (past_daily_color === 'green' &&
                  past_open_ended_color === 'green' &&
                  past_super_feedback_color !== 'red' &&
                  past_recognition_color === 'green' &&
                  past_super_recognition_color !== 'red' &&
                  past_happily_village_color !== 'red' &&
                  past_peerfeedback_color === 'green' ) {
                  
                  state.directReports.engagedValue.oldHighlyEngaged++
                    

                } else if (past_daily_color === 'green' &&
                  past_open_ended_color !== 'red' &&
                  past_recognition_color !== 'red' ) {
                    
                  state.directReports.engagedValue.oldModeratelyEngaged++
                    

                } else if (past_daily_color !== 'red') {
                
                  state.directReports.engagedValue.oldSomewhatEngaged++
                  
                } else {
                
                  state.directReports.engagedValue.oldNotEngaged++
                  

                }
          }






          
          if(allUserKey[user].email==value.email){



            
            checkPeople=false
            var redeem_rewards_color=""
            if(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_count>=1)
            {
              redeem_rewards_color="green"
            }else {
              redeem_rewards_color="red"
            }


            if(_engagement[allUserKey[user].email+"-"+start_date]){
              engagement.challenges.dailyCheck=_engagement[allUserKey[user].email+"-"+start_date].daily_color
              engagement.challenges.peerFeedback=_engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color
              engagement.challenges.feedback=_engagement[allUserKey[user].email+"-"+start_date].feedback_color
              engagement.challenges.happilyVillage=_engagement[allUserKey[user].email+"-"+start_date].happily_village_color
              engagement.challenges.superFeedback=_engagement[allUserKey[user].email+"-"+start_date].super_feedback_color
              engagement.challenges.rewards=redeem_rewards_color//_engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_color
              engagement.challenges.recognition=_engagement[allUserKey[user].email+"-"+start_date].recognition_color
              engagement.challenges.favoritedSparks=_engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color
              engagement.challenges.superRecognition=_engagement[allUserKey[user].email+"-"+start_date].super_recognition_color
              engagement.challenges.NetworkBuilding=networkbulding_color//_engagement[allUserKey[user].email+"-"+start_date].networkbulding_color
            }
            

            
            






            //====setContributions====//
            data_Contribution={
              dailyAttendance:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].daily)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].daily/3),
              dailyAttendanceStatus:daily_color,
              feedbackShared:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].feedback/3),
              feedbackSharedStatus: open_ended_color,
              managerReplyRate:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].replyrate)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].replyrate/3),
              managerReplyRateStatus:replyrate_color,
              insightsOpened:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].insight)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].insight/3*100),
              insightsOpenedStatus:insight_color,
              recognitionGiven:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].recognition)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].recognition/3),
              recognitionGivenStatus:recognition_color,
              peerFeedback:isNaN(quarterData[allUserKey[user].email+"-"+thisQuarter].peerfeedback)?0:(quarterData[allUserKey[user].email+"-"+thisQuarter].peerfeedback/3),
              peerFeedbackStatus:peerfeedback_color,
              
            }


            


            let sortNot_good = _.sortBy(quarterData[allUserKey[user].email+"-"+thisQuarter].report_card_notgood, [function (o: any) { return o.priority; }])
            let good=quarterData[allUserKey[user].email+"-"+thisQuarter].report_card_good
            if(sortNot_good.length==0){
              engagementKey.push(good + " viewpoints that are positive & healthy")
            }else if(sortNot_good.length==1){
              engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
            }else{
              engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
            }
            let setData = {
              name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
              firstname: allUserKey[user].firstname,
              lastname: allUserKey[user].lastname,
              image: allUserKey[user].profilepic,
              teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
              engagedType: engagedType,
              engagementKey: engagementKey,
              sort:engagedSort
            }
            
            engagedData.push(setData)









        
  
       

          if(value.boss){
            if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager){
              ///===team feeling====
              for(let j=0;j<day_quarter;j++){
                const day=format(addDays(new Date(start_date), j), "dd")
                const date=format(addDays(new Date(start_date), j), "YYYY-MM-DD")
                let weekend = format(date, "dd");
              
                if(weekend!=="Su"&&weekend!=="Sa"){
                var _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                  });
                    if(j==0){
                        let dayLabel = format(date, "d");
                        
                        for(let i=1;i<parseInt(dayLabel);i++){
                          feeling.push("#C4C4C4")
          
                            
                        }
                        
                    }
                    if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]&&!_holiday){
                      if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="green"){
                        feeling.push("#27BC6C")
                            status_feeling.good++
                      }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="yellow"){
                        feeling.push("#FFBA0D")
                            status_feeling.okay++
                      }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="red"){
                        feeling.push("#F22F3C")
                        status_feeling.critical++
                      }else{
                        feeling.push("#7B7B7B")
                      }
                    }else{
                        if(_holiday){
                          feeling.push("#C4C4C4")
                            
                        }else{
                          feeling.push("#7B7B7B")
                            
                        }
                    }
                }
                if(j==lastDayOfMonth-1)
                {
                    
                    if(feeling.length<25){
                        for(let i=feeling.length;i<25;i++)
                        {
                          feeling.push("#C4C4C4")
                            
                        }
                        
                    }
    
                }
                
            }
          }else{
            for(let i=feeling.length;i<25;i++)
            {

              feeling.push("#7B7B7B")
            }

          }
                // console.log('status_feeling=======>2',status_feeling)
                // //commit('setFeeling', status_feeling)
                // commit('setTeamFeeling', feeling)
                
    
          }
            

          if(!value.boss){

            PersonalGrowth={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Recognition={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Colleagues={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Satisfaction={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Ambassadorship={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Feedback={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Wellness={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Company_Alignment={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Manager={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}

          }
          
          if(quarterData[allUserKey[user].email+"-"+thisQuarter]){
                if(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions){


                    PersonalGrowth.value=PersonalGrowth.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth.value:0)
                    Recognition.value=Recognition.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition.value:0)
                    Rel_Colleagues.value=Rel_Colleagues.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues.value:0)
                    Satisfaction.value=Satisfaction.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction.value:0)
                    Ambassadorship.value=Ambassadorship.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship.value:0)
                    Feedback.value=Feedback.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback.value:0)
                    Rel_Manager.value=Rel_Manager.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager.value:0)
                    Wellness.value=Wellness.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness.value:0)
                    Company_Alignment.value=Company_Alignment.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment.value:0)





                    PersonalGrowth.total=PersonalGrowth.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth.total:0)
                    Recognition.total=Recognition.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition.total:0)
                    Rel_Colleagues.total=Rel_Colleagues.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues.total:0)
                    Satisfaction.total=Satisfaction.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction.total:0)
                    Ambassadorship.total=Ambassadorship.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship.total:0)
                    Feedback.total=Feedback.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback.total:0)
                    Rel_Manager.total=Rel_Manager.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager.total:0)
                    Wellness.total=Wellness.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness.total:0)
                    Company_Alignment.total=Company_Alignment.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment.total:0)


                }

          }


          if(pastQuarterData[allUserKey[user].email+"-"+past_quarter]){
            if(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions){

              PersonalGrowth.previous_value=PersonalGrowth.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth.value
              Recognition.previous_value=Recognition.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition.value
              Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues.value
              Satisfaction.previous_value=Satisfaction.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction.value
              Ambassadorship.previous_value=Ambassadorship.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship.value
              Feedback.previous_value=Feedback.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback.value
              Rel_Manager.previous_value=Rel_Manager.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager.value
              Wellness.previous_value=Wellness.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness.value
              Company_Alignment.previous_value=Company_Alignment.previous_value+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment.value

              PersonalGrowth.previous_total=PersonalGrowth.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth.total
              Recognition.previous_total=Recognition.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition.total
              Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues.total
              Satisfaction.previous_total=Satisfaction.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction.total
              Ambassadorship.previous_total=Ambassadorship.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship.total
              Feedback.previous_total=Feedback.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback.total
              Rel_Manager.previous_total=Rel_Manager.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager.total
              Wellness.previous_total=Wellness.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness.total
              Company_Alignment.previous_total=Company_Alignment.previous_total+pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment.total
            }
            
          }

          if(!value.boss){
            PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
            Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
            Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
            Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
            Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
            Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
            Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
            Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
            Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));
  
            PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
            PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
            performingData.push(PersonalGrowth)
            Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
            Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
            performingData.push(Recognition)
            Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
            Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
            performingData.push(Rel_Colleagues)
            Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
            Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
            performingData.push(Satisfaction)
            Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
            Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
            performingData.push(Ambassadorship)
            Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
            Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
            performingData.push(Feedback)
            Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
            Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
            performingData.push(Rel_Manager)
            Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
            Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
            performingData.push(Wellness)
            Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
            Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
            performingData.push(Company_Alignment)
              let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
              commit('setPerformingData', _performingData)
          
          }
          if(_engagement[allUserKey[user].email+"-"+start_date]){
          if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Latent Potential'){
            talentClass='a'

          }else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Up-and-coming'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Contributor'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Community Pillar'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Rising Star'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Crowd Favorite'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Untapped Potential'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Engaged Contributor'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Emerging Talent'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Unsung Talent'){
            talentClass='b'
          }
          else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Activated'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Core Player'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='High Potential'){
            talentClass='c'
          }
          else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='High Performer'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Solid Performer'||
          _engagement[allUserKey[user].email+"-"+start_date].talent=='Superstar'){
            talentClass='d'
          }


          
          if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Low Network'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Outer'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Inner'){
            networkClass='a'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Network'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='High Outer'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='High Inner'){
            networkClass='b'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='High Network'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Outer'||
          _engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Inner'){
            networkClass='c'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Network'){
            networkClass='d'
          }
          if(_engagement[allUserKey[user].email+"-"+start_date].truly>=4){
            trulyClass='d'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].truly>=2&&_engagement[allUserKey[user].email+"-"+start_date].truly<=3){
            trulyClass='c'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].truly==1){
            trulyClass='b'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].truly<=0){
            trulyClass='a'
          }

          if(_engagement[allUserKey[user].email+"-"+start_date].star>=6){
            starClass='d'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].star>=4&&_engagement[allUserKey[user].email+"-"+start_date].star<=5){
            starClass='c'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].star>=1&&_engagement[allUserKey[user].email+"-"+start_date].star<=3){
            starClass='b'
          }else if(_engagement[allUserKey[user].email+"-"+start_date].star<=0){
            starClass='a'
          }

          }
          userCardData={
            name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
            firstname: allUserKey[user].firstname,
            lastname: allUserKey[user].lastname,
            image:allUserKey[user].profilepic,
            talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
            email:allUserKey[user].email,
            starPerformer:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].star?_engagement[allUserKey[user].email+"-"+start_date].star:0,
            talent:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent=="Marginalized"?"Starter":(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent=="Hidden Talent"?"Hidden Gem":(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent?_engagement[allUserKey[user].email+"-"+start_date].talent:"-")),
            oldTalent:OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):"",
            excelsAt:result,
            outstanding:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0,
            impact_rating:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0).toFixed(1):0,
            impact_rating_lastweek:_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0).toFixed(1):0,
            impact_rating_change:((_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0):0)-(_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0):0)).toFixed(1),
            network_type:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].network_type?_engagement[allUserKey[user].email+"-"+start_date].network_type:"-",  
            engagedType: engagedType,
            medalCount:medalCount,
            truly:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0, 
            star: _engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].star?_engagement[allUserKey[user].email+"-"+start_date].star:0,
            engagementClass:engagementClass,
            talentClass:talentClass,
            networkClass:networkClass,
            trulyClass:trulyClass,
            starClass:starClass
          }
            // console.log('data_Contribution',data_Contribution)
            commit('setuserCardData', userCardData)
            commit('setYouFeeling', youFeeling)
            commit('setContributions', data_Contribution)
            commit("setEngagement",{...engagement,engagementKey:engagementKey,engagementType:engagedType})

          }else{

            if(quarterData[allUserKey[user].email+"-"+thisQuarter]){
              if(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions){



                      PersonalGrowth.value=PersonalGrowth.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth.value:0)
                      Recognition.value=Recognition.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition.value:0)
                      Rel_Colleagues.value=Rel_Colleagues.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues.value:0)
                      Satisfaction.value=Satisfaction.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction.value:0)
                      Ambassadorship.value=Ambassadorship.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship.value:0)
                      Feedback.value=Feedback.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback.value:0)
                      Rel_Manager.value=Rel_Manager.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager.value:0)
                      Wellness.value=Wellness.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness.value:0)
                      Company_Alignment.value=Company_Alignment.value+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment.value:0)





                      PersonalGrowth.total=PersonalGrowth.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.PersonalGrowth.total:0)
                      Recognition.total=Recognition.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Recognition.total:0)
                      Rel_Colleagues.total=Rel_Colleagues.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Colleagues.total:0)
                      Satisfaction.total=Satisfaction.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Satisfaction.total:0)
                      Ambassadorship.total=Ambassadorship.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Ambassadorship.total:0)
                      Feedback.total=Feedback.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Feedback.total:0)
                      Rel_Manager.total=Rel_Manager.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Rel_Manager.total:0)
                      Wellness.total=Wellness.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Wellness.total:0)
                      Company_Alignment.total=Company_Alignment.total+(quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[allUserKey[user].email+"-"+thisQuarter].dimensions.Company_Alignment.total:0)


              }




                let sortNot_good = _.sortBy(quarterData[allUserKey[user].email+"-"+thisQuarter].report_card_notgood, [function (o: any) { return o.priority; }])
                let good=quarterData[allUserKey[user].email+"-"+thisQuarter].report_card_good
                if(sortNot_good.length==0){
                  engagementKey.push(good + " viewpoints that are positive & healthy")
                }else if(sortNot_good.length==1){
                  engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
                }else{
                  engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
                }
              
                let setData = {
                  name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
                  firstname: allUserKey[user].firstname,
                  lastname: allUserKey[user].lastname,
                  image: allUserKey[user].profilepic,
                  teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
                  engagedType: engagedType,
                  engagementKey: engagementKey,
                  sort:engagedSort
                }
                
                engagedData.push(setData)





            }


            if(pastQuarterData[allUserKey[user].email+"-"+past_quarter]){
              if(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions){


                PersonalGrowth.previous_value=PersonalGrowth.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth.value:0)
                Recognition.previous_value=Recognition.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition.value:0)
                Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues.value:0)
                Satisfaction.previous_value=Satisfaction.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction.value:0)
                Ambassadorship.previous_value=Ambassadorship.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship.value:0)
                Feedback.previous_value=Feedback.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback.value:0)
                Rel_Manager.previous_value=Rel_Manager.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager.value:0)
                Wellness.previous_value=Wellness.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness.value:0)
                Company_Alignment.previous_value=Company_Alignment.previous_value+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment.value:0)
              

              PersonalGrowth.previous_total=PersonalGrowth.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.PersonalGrowth.total:0)
              Recognition.previous_total=Recognition.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Recognition.total:0)
              Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Colleagues.total:0)
              Satisfaction.previous_total=Satisfaction.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Satisfaction.total:0)
              Ambassadorship.previous_total=Ambassadorship.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Ambassadorship.total:0)
              Feedback.previous_total=Feedback.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Feedback.total:0)
              Rel_Manager.previous_total=Rel_Manager.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Rel_Manager.total:0)
              Wellness.previous_total=Wellness.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Wellness.total:0)
              Company_Alignment.previous_total=Company_Alignment.previous_total+(pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment?pastQuarterData[allUserKey[user].email+"-"+past_quarter].dimensions.Company_Alignment.total:0)
              }
            }
            



            



            
          
        


            if(_engagement[allUserKey[user].email+"-"+start_date]){
                // let sortNot_good = _.sortBy(_engagement[allUserKey[user].email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
                // let good=_engagement[allUserKey[user].email+"-"+start_date].report_card_good
                // if(sortNot_good.length==0){
                //   engagementKey.push(good + " viewpoints that are positive & healthy")
                // }else if(sortNot_good.length==1){
                //   engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
                // }else{
                //   engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
                // }
              
                // let setData = {
                //   name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
                //   firstname: allUserKey[user].firstname,
                //   lastname: allUserKey[user].lastname,
                //   image: allUserKey[user].profilepic,
                //   teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
                //   engagedType: engagedType,
                //   engagementKey: engagementKey,
                //   sort:engagedSort
                // }
                
                // engagedData.push(setData)
              
                growingTeam.push({
                  name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
                  firstname: allUserKey[user].firstname,
                  lastname: allUserKey[user].lastname,
                  image:allUserKey[user].profilepic,
                  talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
                  email:allUserKey[user].email,
                  starPerformer:_engagement[allUserKey[user].email+"-"+start_date].star,
                  talent:_engagement[allUserKey[user].email+"-"+start_date].talent=="Marginalized"?"Starter":(_engagement[allUserKey[user].email+"-"+start_date].talent=="Hidden Talent"?"Hidden Gem":(_engagement[allUserKey[user].email+"-"+start_date].talent?_engagement[allUserKey[user].email+"-"+start_date].talent:"-")),
                  oldTalent:OldtalentTeam[user]==allUserKey[user].talent?(""):(OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):""),
                  excelsAt:result,
                  excelsCount:result.length,
                  outstanding:_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0,
                  impact_rating:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0).toFixed(1):0,
                  impact_rating_lastweek:_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0).toFixed(1):0,
                  impact_rating_change:((_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0):0)-(_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0):0)).toFixed(1),            
                  network_type:_engagement[allUserKey[user].email+"-"+start_date].network_type?_engagement[allUserKey[user].email+"-"+start_date].network_type:"-",
                  engagedType: engagedType,
                  medalCount:medalCount,
                  truly:_engagement[allUserKey[user].email+"-"+start_date].truly, 
                  star:_engagement[allUserKey[user].email+"-"+start_date].star
              })
            }



          }
        }





        if(value.boss){
      
          PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
          Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
          Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
          Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
          Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
          Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
          Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
          Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
          Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

          PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
          PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
          performingData.push(PersonalGrowth)
          Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
          Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
          performingData.push(Recognition)
          Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
          Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
          performingData.push(Rel_Colleagues)
          Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
          Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
          performingData.push(Satisfaction)
          Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
          Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
          performingData.push(Ambassadorship)
          Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
          Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
          performingData.push(Feedback)
          Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
          Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
          performingData.push(Rel_Manager)
          Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
          Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
          performingData.push(Wellness)
          Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
          Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
          performingData.push(Company_Alignment)
          
          let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
          commit('setPerformingData', _performingData)
          

        }
        if(checkPeople){
              var networkbulding_color=""
              let engagementKey: Array<any> = []
              let engagedType: string = ''
              let engagedSort=0








          let super_feedback = 0;
          let super_feedback_color = 'red';
          super_feedback = isNaN(quarterData[value.email+"-"+thisQuarter].super_feedback)?0:(quarterData[value.email+"-"+thisQuarter].super_feedback/3)
          if(super_feedback > 50){
            super_feedback_color = 'green';
          }else if(super_feedback >= 25){
            super_feedback_color = 'yellow';
          }

          let super_recognition_color = 'red';
          let super_recognition = isNaN(quarterData[value.email+"-"+thisQuarter].super_recognition)?0:(quarterData[value.email+"-"+thisQuarter].super_recognition/3)
          if(super_recognition >= 50){
            super_recognition_color = 'green';
          }else if(super_recognition >= 25){
            super_recognition_color = 'yellow';
          }

          let happily_village_color = 'red';
          let happily_village = isNaN(quarterData[value.email+"-"+thisQuarter].happily_village)?0:(quarterData[value.email+"-"+thisQuarter].happily_village/3)
          if (happily_village >= 5) {
            happily_village_color = 'green';
          } else if (happily_village >= 1) {
            happily_village_color = 'yellow';
          } 
        





      const insight=isNaN(quarterData[value.email+"-"+thisQuarter].insight)?0:(quarterData[value.email+"-"+thisQuarter].insight/3)
      let insight_color = 'red';
          if (insight >= 0.75){
            insight_color = 'green';
          }else if (insight >= 0.40){
            insight_color = 'yellow';
          }
          const replyrate=isNaN(quarterData[value.email+"-"+thisQuarter].replyrate)?0:(quarterData[value.email+"-"+thisQuarter].replyrate/3)
          let replyrate_color = 'red';
          if (replyrate >= 0.6) {
            replyrate_color = 'green';
          } else if (replyrate >= 0.30) {
            replyrate_color = 'yellow';
          }
          const peerfeedback=isNaN(quarterData[value.email+"-"+thisQuarter].peerfeedback)?0:(quarterData[value.email+"-"+thisQuarter].peerfeedback/3)

          const daily=isNaN(quarterData[value.email+"-"+thisQuarter].daily)?0:(quarterData[value.email+"-"+thisQuarter].daily/3)
          let daily_color = 'red';

          if (daily >= 0.75) {
              daily_color = 'green';
            } else if (daily >= 0.50) {
              daily_color = 'yellow';
            }
            let open_ended_color = 'red';
          const number_of_open_ended=isNaN(quarterData[value.email+"-"+thisQuarter].open_ended)?0:(quarterData[value.email+"-"+thisQuarter].open_ended/3)
          if(number_of_open_ended >= 0.75){
              open_ended_color = 'green';
          }else if(number_of_open_ended >= 0.40){
              open_ended_color = 'yellow';
          }

          const recognition=isNaN(quarterData[value.email+"-"+thisQuarter].recognition)?0:(quarterData[value.email+"-"+thisQuarter].recognition/3)

          let recognition_color = 'red';
          if (recognition >= 0.5) {
              recognition_color = 'green';
          } else if (recognition >= 0.25) {
              recognition_color = 'yellow';
          }


      const peerfeedback_color=(peerfeedback >= 1)?'green':'red'










          if(!quarterData[value.email+"-"+thisQuarter].daily_answer){
            engagedType = "inActive"
            engagedSort=6
            state.directReports.engagedValue.inActive++
            engagementClass='a'
          }else if(daily_color === 'green' && 
            open_ended_color === 'green' && 
            super_feedback_color !== 'red' && 
            recognition_color === 'green' && 
            super_recognition_color !== 'red' &&
            happily_village_color !== 'red' && 
            peerfeedback_color === 'green'){
            engagedType = "highlyEngaged"
            engagedSort=2
            engagementClass='d'
            state.directReports.engagedValue.highlyEngaged++

          }else if(daily_color === 'green' && 
            open_ended_color !== 'red' && 
            recognition_color !== 'red'){
            engagedType = "moderatelyEngaged"
            engagedSort=3
            state.directReports.engagedValue.moderatelyEngaged++
            engagementClass='c'

          }else if(daily_color !== 'red'){
            engagedType = "somewhatEngaged"
            engagedSort=4
            state.directReports.engagedValue.somewhatEngaged++
            engagementClass='b'
          }else{
            engagedType = "underEngaged"
            engagedSort=5
            state.directReports.engagedValue.notEngaged++
            engagementClass='a'
          }






           //=====past quarter=====  

           if(pastQuarterData[value.email+"-"+past_quarter]){
                let past_super_feedback = 0;
                let past_super_feedback_color = 'red';
                past_super_feedback = isNaN(pastQuarterData[value.email+"-"+past_quarter].super_feedback)?0:(pastQuarterData[value.email+"-"+past_quarter].super_feedback/3)
                if(past_super_feedback > 50){
                  past_super_feedback_color = 'green';
                }else if(past_super_feedback >= 25){
                  past_super_feedback_color = 'yellow';
                }

                let past_super_recognition_color = 'red';
                let past_super_recognition = isNaN(pastQuarterData[value.email+"-"+past_quarter].super_recognition)?0:(pastQuarterData[value.email+"-"+past_quarter].super_recognition/3)
                if(past_super_recognition >= 50){
                  past_super_recognition_color = 'green';
                }else if(past_super_recognition >= 25){
                  past_super_recognition_color = 'yellow';
                }


                let past_happily_village_color = 'red';
                let past_happily_village = isNaN(pastQuarterData[value.email+"-"+past_quarter].happily_village)?0:(pastQuarterData[value.email+"-"+past_quarter].happily_village/3)
                if (past_happily_village >= 5) {
                  past_happily_village_color = 'green';
                } else if (past_happily_village >= 1) {
                  past_happily_village_color = 'yellow';
                } 


                const past_peerfeedback=isNaN(pastQuarterData[value.email+"-"+past_quarter].peerfeedback)?0:(pastQuarterData[value.email+"-"+past_quarter].peerfeedback/3)

                const past_daily=isNaN(pastQuarterData[value.email+"-"+past_quarter].daily)?0:(pastQuarterData[value.email+"-"+past_quarter].daily/3)
                let past_daily_color = 'red';

                if (past_daily >= 0.75) {
                    past_daily_color = 'green';
                  } else if (past_daily >= 0.50) {
                    past_daily_color = 'yellow';
                  }
                  let past_open_ended_color = 'red';
                  const past_number_of_open_ended=isNaN(pastQuarterData[value.email+"-"+past_quarter].open_ended)?0:(pastQuarterData[value.email+"-"+past_quarter].open_ended/3)
                  if(past_number_of_open_ended >= 0.75){
                      past_open_ended_color = 'green';
                  }else if(past_number_of_open_ended >= 0.40){
                      past_open_ended_color = 'yellow';
                  }

                  const past_recognition=isNaN(pastQuarterData[value.email+"-"+past_quarter].recognition)?0:(pastQuarterData[value.email+"-"+past_quarter].recognition/3)

                  let past_recognition_color = 'red';
                  if (past_recognition >= 0.5) {
                      past_recognition_color = 'green';
                  } else if (past_recognition >= 0.25) {
                      past_recognition_color = 'yellow';
                  }


                  const past_peerfeedback_color=(past_peerfeedback >= 1)?'green':'red'

    



          



            
          
                  //======old=======
                if(!pastQuarterData[value.email+"-"+past_quarter].daily_answer){
                
                  state.directReports.engagedValue.oldInActive++
                }
                else if (past_daily_color === 'green' &&
                  past_open_ended_color === 'green' &&
                  past_super_feedback_color !== 'red' &&
                  past_recognition_color === 'green' &&
                  past_super_recognition_color !== 'red' &&
                  past_happily_village_color !== 'red' &&
                  past_peerfeedback_color === 'green' ) {
                  
                  state.directReports.engagedValue.oldHighlyEngaged++
                    

                } else if (past_daily_color === 'green' &&
                  past_open_ended_color !== 'red' &&
                  past_recognition_color !== 'red' ) {
                    
                  state.directReports.engagedValue.oldModeratelyEngaged++
                    

                } else if (past_daily_color !== 'red') {
                
                  state.directReports.engagedValue.oldSomewhatEngaged++
                  
                } else {
                
                  state.directReports.engagedValue.oldNotEngaged++
                  

                }
          }




     
              
         
              
          var result:Array<any>=[]
          if(_engagement[value.email+"-"+start_date]){
          for (const excel in _engagement[value.email+"-"+start_date].excels) {
            let data={name:excel,value:_engagement[value.email+"-"+start_date].excels[excel]}
            result.push(data)
          }
        }
          if((state.userDetail.newInnerNetwork+state.userDetail.newOuterNetwork)>0){
            networkbulding_color="green"
          }
          else{
            networkbulding_color="red"
          }
          var redeem_rewards_color=""
          if(_engagement[value.email+"-"+start_date].redeem_rewards_count>=1)
          {
            redeem_rewards_color="green"
          }else {
            redeem_rewards_color="red"
          }








          if(_engagement[value.email+"-"+start_date]){
          engagement.challenges.dailyCheck=_engagement[value.email+"-"+start_date].daily_color
          engagement.challenges.peerFeedback=_engagement[value.email+"-"+start_date].peerfeedback_color
          engagement.challenges.feedback=_engagement[value.email+"-"+start_date].feedback_color
          engagement.challenges.happilyVillage=_engagement[value.email+"-"+start_date].happily_village_color
          engagement.challenges.superFeedback=_engagement[value.email+"-"+start_date].super_feedback_color
          engagement.challenges.rewards=redeem_rewards_color//_engagement[value.email+"-"+start_date].redeem_rewards_color
          engagement.challenges.recognition=_engagement[value.email+"-"+start_date].recognition_color
          engagement.challenges.favoritedSparks=_engagement[value.email+"-"+start_date].favorite_spark_color
          engagement.challenges.superRecognition=_engagement[value.email+"-"+start_date].super_recognition_color
          engagement.challenges.NetworkBuilding=networkbulding_color//_engagement[value.email+"-"+start_date].networkbulding_color



      
       
        

          


            if(value.boss){
              if(_engagement[value.email+"-"+start_date].insight_teams_manager){
                ///===team feeling====
                for(let j=0;j<day_quarter;j++){
                    const day=parseInt(format(addDays(new Date(start_date), j), "dd"))
                    const date=format(addDays(new Date(start_date), j), "YYYY-MM-DD")
                  let weekend = format(date, "dd");
                
                  if(weekend!=="Su"&&weekend!=="Sa"){
                  var _holiday = _.find(holiday, function(value){
                      return value != null && value.date == date;
                    });
                      if(j==0){
                          let dayLabel = format(date, "d");
                          
                          for(let i=1;i<parseInt(dayLabel);i++){
                            feeling.push("#C4C4C4")
                              
                          }
                          
                      }
                      if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]&&!_holiday){
                        if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="green"){
                          feeling.push("#27BC6C")
                              status_feeling.good++
                        }else if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="yellow"){
                          feeling.push("#FFBA0D")
                              status_feeling.okay++
                        }else if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="red"){
                          feeling.push("#F22F3C")
                          status_feeling.critical++
                        }else{
                          feeling.push("#7B7B7B")
                        }
                      }else{
                          if(_holiday){
                            feeling.push("#C4C4C4")
                              
                          }else{
                            feeling.push("#7B7B7B")
                              
                          }
                      }
                  }
                  if(j==lastDayOfMonth-1)
                  {
                      
                      if(feeling.length<25){
                          for(let i=feeling.length;i<25;i++)
                          {
                            feeling.push("#C4C4C4")
                              
                          }
                          
                      }
      
                  }
                  
              }
            }else{
              for(let i=feeling.length;i<25;i++)
              {

                feeling.push("#7B7B7B")
              }

            }

            

                  //commit('setFeeling', status_feeling)
                  commit('setTeamFeeling', feeling)
                  
      
            }
          }

          if(!value.boss){

            PersonalGrowth={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Recognition={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Colleagues={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Satisfaction={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Ambassadorship={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Feedback={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Wellness={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Company_Alignment={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Manager={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}

          }


          if(quarterData[value.email+"-"+thisQuarter]){
              if(quarterData[value.email+"-"+thisQuarter].dimensions){


                  PersonalGrowth.value=PersonalGrowth.value+(quarterData[value.email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[value.email+"-"+thisQuarter].dimensions.PersonalGrowth.value:0)
                  Recognition.value=Recognition.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Recognition?quarterData[value.email+"-"+thisQuarter].dimensions.Recognition.value:0)
                  Rel_Colleagues.value=Rel_Colleagues.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Colleagues.value:0)
                  Satisfaction.value=Satisfaction.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[value.email+"-"+thisQuarter].dimensions.Satisfaction.value:0)
                  Ambassadorship.value=Ambassadorship.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[value.email+"-"+thisQuarter].dimensions.Ambassadorship.value:0)
                  Feedback.value=Feedback.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Feedback?quarterData[value.email+"-"+thisQuarter].dimensions.Feedback.value:0)
                  Rel_Manager.value=Rel_Manager.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Manager.value:0)
                  Wellness.value=Wellness.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Wellness?quarterData[value.email+"-"+thisQuarter].dimensions.Wellness.value:0)
                  Company_Alignment.value=Company_Alignment.value+(quarterData[value.email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[value.email+"-"+thisQuarter].dimensions.Company_Alignment.value:0)





                  PersonalGrowth.total=PersonalGrowth.total+(quarterData[value.email+"-"+thisQuarter].dimensions.PersonalGrowth?quarterData[value.email+"-"+thisQuarter].dimensions.PersonalGrowth.total:0)
                  Recognition.total=Recognition.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Recognition?quarterData[value.email+"-"+thisQuarter].dimensions.Recognition.total:0)
                  Rel_Colleagues.total=Rel_Colleagues.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Colleagues?quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Colleagues.total:0)
                  Satisfaction.total=Satisfaction.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Satisfaction?quarterData[value.email+"-"+thisQuarter].dimensions.Satisfaction.total:0)
                  Ambassadorship.total=Ambassadorship.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Ambassadorship?quarterData[value.email+"-"+thisQuarter].dimensions.Ambassadorship.total:0)
                  Feedback.total=Feedback.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Feedback?quarterData[value.email+"-"+thisQuarter].dimensions.Feedback.total:0)
                  Rel_Manager.total=Rel_Manager.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Manager?quarterData[value.email+"-"+thisQuarter].dimensions.Rel_Manager.total:0)
                  Wellness.total=Wellness.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Wellness?quarterData[value.email+"-"+thisQuarter].dimensions.Wellness.total:0)
                  Company_Alignment.total=Company_Alignment.total+(quarterData[value.email+"-"+thisQuarter].dimensions.Company_Alignment?quarterData[value.email+"-"+thisQuarter].dimensions.Company_Alignment.total:0)


              }

          }


          if(pastQuarterData[value.email+"-"+past_quarter]){
            if(quarterData[value.email+"-"+thisQuarter].dimensions){

              PersonalGrowth.previous_value=PersonalGrowth.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.PersonalGrowth.value
              Recognition.previous_value=Recognition.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Recognition.value
              Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Rel_Colleagues.value
              Satisfaction.previous_value=Satisfaction.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Satisfaction.value
              Ambassadorship.previous_value=Ambassadorship.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Ambassadorship.value
              Feedback.previous_value=Feedback.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Feedback.value
              Rel_Manager.previous_value=Rel_Manager.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Rel_Manager.value
              Wellness.previous_value=Wellness.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Wellness.value
              Company_Alignment.previous_value=Company_Alignment.previous_value+pastQuarterData[value.email+"-"+past_quarter].dimensions.Company_Alignment.value

              PersonalGrowth.previous_total=PersonalGrowth.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.PersonalGrowth.total
              Recognition.previous_total=Recognition.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Recognition.total
              Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Rel_Colleagues.total
              Satisfaction.previous_total=Satisfaction.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Satisfaction.total
              Ambassadorship.previous_total=Ambassadorship.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Ambassadorship.total
              Feedback.previous_total=Feedback.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Feedback.total
              Rel_Manager.previous_total=Rel_Manager.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Rel_Manager.total
              Wellness.previous_total=Wellness.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Wellness.total
              Company_Alignment.previous_total=Company_Alignment.previous_total+pastQuarterData[value.email+"-"+past_quarter].dimensions.Company_Alignment.total
            }
            
          }


       
          if(!value.boss){
            PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
            Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
            Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
            Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
            Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
            Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
            Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
            Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
            Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

            PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
            PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
            performingData.push(PersonalGrowth)
            Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
            Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
            performingData.push(Recognition)
            Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
            Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
            performingData.push(Rel_Colleagues)
            Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
            Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
            performingData.push(Satisfaction)
            Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
            Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
            performingData.push(Ambassadorship)
            Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
            Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
            performingData.push(Feedback)
            Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
            Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
            performingData.push(Rel_Manager)
            Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
            Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
            performingData.push(Wellness)
            Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
            Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
            performingData.push(Company_Alignment)
              let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
              commit('setPerformingData', _performingData)
          
          }
        
          userCardData={
            name: (value.firstname+" "+value.lastname.slice(0, 1)),
            firstname: value.firstname,
            lastname: value.lastname,
            image:value.profilepic,
            talentChanged:OldtalentTeam[value.email]?(value.talent===OldtalentTeam[value.email]?true:false):false, 
            email:value.email,
            starPerformer:value.star,
            talent:value.talent=="Marginalized"?"Starter":(value.talent=="Hidden Talent"?"Hidden Gem":value.talent),
            oldTalent:OldtalentTeam[value.email]?OldtalentTeam[value.email]=="Marginalized"?"Starter":(OldtalentTeam[value.email]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[value.email]):"",
            excelsAt:result,
            outstanding:_engagement[value.email+"-"+start_date].truly?_engagement[value.email+"-"+start_date].truly:0
          }

          // console.log('userCardData111',data_Contribution)
          commit('setuserCardData', userCardData)
          commit('setYouFeeling', youFeeling)
          commit('setContributions', data_Contribution)
          commit("setEngagement",{...engagement,engagementKey:engagementKey,engagementType:engagedType})




        }
        commit("setLoadingProgress",state.loadingProgress+25)
        directReports.map(data=>{
          const emailKey = value.email.replace(/\./g, '||')
          data.value=talentTeam[data.name]?talentTeam[data.name]:0
          data.highlight=value.talent===data.name?true:false
          data.oldhighlight=OldtalentTeam[emailKey]===data.name?true:false
          data.name=data.name=="Marginalized"?"Starter":(data.name=="Hidden Talent"?"Hidden Gem":data.name)
      })

      //console.log("growingTeam",growingTeam)
        // console.log('directReports',directReports)
        // console.log('state.directReports',state.directReports)

        commit('setGrowingData', {directReports:directReports})
        commit("setDirectReportsEngagedData",  _.sortBy(engagedData, [function (o: any) { return o.sort; }]))
        commit('setPartTalentTeam',_.orderBy(growingTeam, ['impact_rating', 'name'], ['desc','asc']))
        commit("setDirectReportsLoading", false)
        commit('setloading', false)
        commit("setloadingStatus",false)
        setTimeout(() => { 
          commit("setLoadingProgress",state.loadingProgress+26)
        }, 1000)
        
      })
      
    },
    getRingImage({ commit, dispatch, rootState, state ,getters}: any,data:any) {
            let imageName = ''
            const reflection=data.reflection
            const skill=data.skill
            const movement=data.movement
            const sleep=data.sleep
        
            if(reflection !== ''){
                if(skill === ''){
                    if(reflection === 'h'){
                        if(movement === '' && sleep === '') {
                            imageName = "ring_0_0_null_null.png"//require('../images/spark/ring/ring_0_0_null_null.png');
                        }else if(movement === '0' && sleep === '0') {
                            imageName ="ring_0_0_0_0.png"// require('../images/spark/ring/ring_0_0_0_0.png');
                        }else if (movement === '1' && sleep === '1') {
                            imageName = "ring_0_0_1_1.png"//require('../images/spark/ring/ring_0_0_1_1.png'); 
                        }else if (movement === '0' && sleep === '1') {
                            imageName = "ring_0_0_0_1.png"//require('../images/spark/ring/ring_0_0_0_1.png'); 
                        }else if (movement === '1' && sleep === '0') {
                            imageName = "ring_0_0_1_0.png"//require('../images/spark/ring/ring_0_0_1_0.png');
                        }else if(movement === '' && sleep === '0') { 
                            imageName = "ring_0_0_null_0.png"//require('../images/spark/ring/ring_0_0_null_0.png');
                        }else if(movement === '' && sleep === '1') {
                            imageName = "ring_0_0_null_1.png"//require('../images/spark/ring/ring_0_0_null_1.png');
                        }else if(movement === 0 && sleep === '') {
                            imageName = "ring_0_0_0_null.png"//require('../images/spark/ring/ring_0_0_0_null.png');
                        }else if(movement === '1' && sleep === '') {
                            imageName = "ring_0_0_1_null.png"//require('../images/spark/ring/ring_0_0_1_null.png');
                        }else{
                            imageName ="no_ring.png" //require('../images/spark/ring/no_ring.png');
                        }
                    }else{
                        if(movement === '' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_null_null.png"//require('../images/spark/ring/ring_r_0_null_null.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_null_null.png"//require('../images/spark/ring/ring_g_0_null_null.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_null.png"//require('../images/spark/ring/ring_y_0_null_null.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '0' && sleep === '0') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_0.png"//require('../images/spark/ring/ring_r_0_0_0.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_0.png"//require('../images/spark/ring/ring_g_0_0_0.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_0.png"//require('../images/spark/ring/ring_y_0_0_0.png');
                            }else{
                                imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                            }
                        } else if (movement === '1' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_1_1.png"//require('../images/spark/ring/ring_r_0_1_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_1.png"//require('../images/spark/ring/ring_g_0_1_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_1_1.png"//require('../images/spark/ring/ring_y_0_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if (movement === '0' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_1.png"//require('../images/spark/ring/ring_r_0_0_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_1.png"//require('../images/spark/ring/ring_g_0_0_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_1.png"//require('../images/spark/ring/ring_y_0_0_1.png');
                            }else{
                                imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if (movement === '1' && sleep === '0') {
                            if(reflection === 'r'){   
                                imageName =  "ring_r_0_1_0.png"//require('../images/spark/ring/ring_r_0_1_0.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_0.png"//require('../images/spark/ring/ring_g_0_1_0.png');
                            }else if(reflection === 'y'){
                                imageName =  "ring_y_0_1_0.png"//require('../images/spark/ring/ring_y_0_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '' && sleep === '0') { 
                            if(reflection === 'r'){   
                                imageName =  "ring_r_0_null_0.png"//require('../images/spark/ring/ring_r_0_null_0.png');
                            }else if(reflection === 'g'){
                                imageName =  "ring_g_0_null_0.png"//require('../images/spark/ring/ring_g_0_null_0.png'); 
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_0.png"//require('../images/spark/ring/ring_y_0_null_0.png'); 
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_null_1.png"//require('../images/spark/ring/ring_r_0_null_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_null_1.png"//require('../images/spark/ring/ring_g_0_null_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_1.png"//require('../images/spark/ring/ring_y_0_null_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '0' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_null.png"//require('../images/spark/ring/ring_r_0_0_null.png'); 
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_null.png"//require('../images/spark/ring/ring_g_0_0_null.png'); 
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_null.png"//require('../images/spark/ring/ring_y_0_0_null.png'); 
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '1' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_1_null.png"//require('../images/spark/ring/ring_r_0_1_null.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_null.png"//require('../images/spark/ring/ring_g_0_1_null.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_1_null.png"//require('../images/spark/ring/ring_y_0_1_null.png');
                            }else{
                                imageName =  "no_ring.png" //require('../images/spark/ring/no_ring.png');
                            }
                        }else{
                            imageName =  "no_ring.png" //require('../images/spark/ring/no_ring.png');
                        }
                    }
                }else if(skill !== '' && movement === '' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_null_null.png"//require('../images/spark/ring/ring_r_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_null.png"//require('../images/spark/ring/ring_r_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_null_null.png"//require('../images/spark/ring/ring_r_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_r_l_null_null.png"//require('../images/spark/ring/ring_r_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_null_null.png"//require('../images/spark/ring/ring_r_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_null_null.png"//require('../images/spark/ring/ring_r_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_null_null.png"//require('../images/spark/ring/ring_r_skip_null_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_null.png"//require('../images/spark/ring/ring_g_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_null_null.png"//require('../images/spark/ring/ring_g_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_g_c_null_null.png"//require('../images/spark/ring/ring_g_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_null.png"//require('../images/spark/ring/ring_g_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_null.png"//require('../images/spark/ring/ring_g_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_null.png"//require('../images/spark/ring/ring_g_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_null.png"//require('../images/spark/ring/ring_g_skip_null_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_null_null.png"//require('../images/spark/ring/ring_y_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_null_null.png"//require('../images/spark/ring/ring_y_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_y_c_null_null.png"//require('../images/spark/ring/ring_y_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_null_null.png"//require('../images/spark/ring/ring_y_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName =  "ring_y_i_null_null.png"//require('../images/spark/ring/ring_y_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_null_null.png"//require('../images/spark/ring/ring_y_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_null_null.png"//require('../images/spark/ring/ring_y_skip_null_null.png');
                        }else{
                            imageName ="no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement !== '' && sleep !== '') {
                    if(movement === '0' && sleep === '0') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_0_0.png"//require('../images/spark/ring/ring_r_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_0_0.png"//require('../images/spark/ring/ring_r_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_0_0.png"//require('../images/spark/ring/ring_r_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_0_0.png"//require('../images/spark/ring/ring_r_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_0_0.png"//require('../images/spark/ring/ring_r_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_0_0.png"//require('../images/spark/ring/ring_r_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_r_skip_0_0.png"//require('../images/spark/ring/ring_r_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_0_0.png"//require('../images/spark/ring/ring_g_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_0_0.png"//require('../images/spark/ring/ring_g_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_0_0.png"//require('../images/spark/ring/ring_g_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_0_0.png"//require('../images/spark/ring/ring_g_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_0_0.png"//require('../images/spark/ring/ring_g_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_0_0.png"//require('../images/spark/ring/ring_g_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_0_0.png"//require('../images/spark/ring/ring_g_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_0_0.png"//require('../images/spark/ring/ring_y_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_0_0.png"//require('../images/spark/ring/ring_y_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_0_0.png"//require('../images/spark/ring/ring_y_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_y_l_0_0.png"//require('../images/spark/ring/ring_y_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_y_i_0_0.png"//require('../images/spark/ring/ring_y_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_0_0.png"//require('../images/spark/ring/ring_y_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_0_0.png"//require('../images/spark/ring/ring_y_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '1' && sleep === '1') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName ="ring_r_e_1_1.png"// require('../images/spark/ring/ring_r_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_1_1.png"//require('../images/spark/ring/ring_r_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_1_1.png"//require('../images/spark/ring/ring_r_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_1_1.png"//require('../images/spark/ring/ring_r_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_1_1.png"//require('../images/spark/ring/ring_r_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_1_1.png"//require('../images/spark/ring/ring_r_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName =  "ring_r_skip_1_1.png"//require('../images/spark/ring/ring_r_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_1_1.png"//require('../images/spark/ring/ring_g_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_1_1.png"//require('../images/spark/ring/ring_g_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_1_1.png"//require('../images/spark/ring/ring_g_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_1_1.png"//require('../images/spark/ring/ring_g_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_1_1.png"//require('../images/spark/ring/ring_g_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_1_1.png"//require('../images/spark/ring/ring_g_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_1_1.png"//require('../images/spark/ring/ring_g_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_1_1.png"//require('../images/spark/ring/ring_y_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_1_1.png"//require('../images/spark/ring/ring_y_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_1_1.png"//require('../images/spark/ring/ring_y_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName =  "ring_y_l_1_1.png"//require('../images/spark/ring/ring_y_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_y_i_1_1.png"//require('../images/spark/ring/ring_y_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_1_1.png"//require('../images/spark/ring/ring_y_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_1_1.png"//require('../images/spark/ring/ring_y_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '0' && sleep === '1') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_0_1.png"//require('../images/spark/ring/ring_r_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_0_1.png"//require('../images/spark/ring/ring_r_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_0_1.png"//require('../images/spark/ring/ring_r_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_0_1.png"//require('../images/spark/ring/ring_r_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_0_1.png"//require('../images/spark/ring/ring_r_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_0_1.png"//require('../images/spark/ring/ring_r_o_0_1.png');
                            }else if(skill === 'skip'){
                                
                                imageName = "ring_r_skip_0_1.png"//require('../images/spark/ring/ring_r_skip_0_1.png');
                            }else{
                                imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_0_1.png"//require('../images/spark/ring/ring_g_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_0_1.png"//require('../images/spark/ring/ring_g_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName ="ring_g_c_0_1.png"// require('../images/spark/ring/ring_g_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName ="ring_g_l_0_1.png"// require('../images/spark/ring/ring_g_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_0_1.png"//require('../images/spark/ring/ring_g_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_0_1.png"//require('../images/spark/ring/ring_g_o_0_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_0_1.png"//require('../images/spark/ring/ring_g_skip_0_1.png');
                            }else{
                                imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_0_1.png"//require('../images/spark/ring/ring_y_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_0_1.png"//require('../images/spark/ring/ring_y_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_0_1.png"//require('../images/spark/ring/ring_y_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_y_l_0_1.png"//require('../images/spark/ring/ring_y_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName =  "ring_y_i_0_1.png"//require('../images/spark/ring/ring_y_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_0_1.png"//require('../images/spark/ring/ring_y_o_0_1.png');
                            }else if(skill === 'skip'){
                           
                                imageName = "ring_y_skip_0_1.png"//require('../images/spark/ring/ring_y_skip_0_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '1' && sleep === '0') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_1_0.png"//require('../images/spark/ring/ring_r_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_1_0.png"//require('../images/spark/ring/ring_r_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_1_0.png"//require('../images/spark/ring/ring_r_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_1_0.png"//require('../images/spark/ring/ring_r_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_1_0.png"//require('../images/spark/ring/ring_r_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_1_0.png"//require('../images/spark/ring/ring_r_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_r_skip_1_0.png"//require('../images/spark/ring/ring_r_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName =  "ring_g_e_1_0.png"//require('../images/spark/ring/ring_g_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_1_0.png"//require('../images/spark/ring/ring_g_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_1_0.png"//require('../images/spark/ring/ring_g_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_1_0.png"//require('../images/spark/ring/ring_g_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_1_0.png"//require('../images/spark/ring/ring_g_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName =  "ring_g_o_1_0.png"//require('../images/spark/ring/ring_g_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName =  "ring_g_skip_1_0.png"//require('../images/spark/ring/ring_g_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_1_0.png"//require('../images/spark/ring/ring_y_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_1_0.png"//require('../images/spark/ring/ring_y_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName =  "ring_y_c_1_0.png"//require('../images/spark/ring/ring_y_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName ="ring_y_l_1_0.png"// require('../images/spark/ring/ring_y_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName ="ring_y_i_1_0.png"//require('../images/spark/ring/ring_y_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_1_0.png"//require('../images/spark/ring/ring_y_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_1_0.png"//require('../images/spark/ring/ring_y_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '' && sleep === '0') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName =  "ring_r_e_null_0.png"//require('../images/spark/ring/ring_r_e_null_0.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_0.png"//require('../images/spark/ring/ring_r_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_null_0.png"//require('../images/spark/ring/ring_r_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName = "ring_r_l_null_0.png"//require('../images/spark/ring/ring_r_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_null_0.png"//require('../images/spark/ring/ring_r_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_null_0.png"//require('../images/spark/ring/ring_r_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_null_0.png"//require('../images/spark/ring/ring_r_skip_null_0.png');
                        }else{
                            imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_0.png"//require('../images/spark/ring/ring_g_e_null_0.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_null_0.png"//require('../images/spark/ring/ring_g_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_null_0.png"//require('../images/spark/ring/ring_g_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_0.png"//require('../images/spark/ring/ring_g_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_0.png"//require('../images/spark/ring/ring_g_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_0.png"//require('../images/spark/ring/ring_g_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_0.png"//require('../images/spark/ring/ring_g_skip_null_0.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName ="ring_y_e_null_0.png"// require('../images/spark/ring/ring_y_e_null_0.png');
                        }else if(skill === 's'){
                            imageName ="ring_y_s_null_0.png"// require('../images/spark/ring/ring_y_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_null_0.png"//require('../images/spark/ring/ring_y_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName ="ring_y_l_null_0.png"// require('../images/spark/ring/ring_y_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_null_0.png"//require('../images/spark/ring/ring_y_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName ="ring_y_o_null_0.png"// require('../images/spark/ring/ring_y_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName ="ring_y_skip_null_0.png"// require('../images/spark/ring/ring_y_skip_null_0.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '' && sleep === '1') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_null_1.png"// require('../images/spark/ring/ring_r_e_null_1.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_1.png"// require('../images/spark/ring/ring_r_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_r_c_null_1.png"//require('../images/spark/ring/ring_r_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName =  "ring_r_l_null_1.png"//require('../images/spark/ring/ring_r_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName =  "ring_r_i_null_1.png"//require('../images/spark/ring/ring_r_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName =  "ring_r_o_null_1.png"//require('../images/spark/ring/ring_r_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName =  "ring_r_skip_null_1.png"//require('../images/spark/ring/ring_r_skip_null_1.png');
                        }else{
                            imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_1.png"//require('../images/spark/ring/ring_g_e_null_1.png');
                        }else if(skill === 's'){
                            imageName ="ring_g_s_null_1.png"// require('../images/spark/ring/ring_g_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_null_1.png"//require('../images/spark/ring/ring_g_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_1.png"//require('../images/spark/ring/ring_g_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_1.png"//require('../images/spark/ring/ring_g_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_1.png"//require('../images/spark/ring/ring_g_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_1.png"//require('../images/spark/ring/ring_g_skip_null_1.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_null_1.png"//require('../images/spark/ring/ring_y_e_null_1.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_null_1.png"//require('../images/spark/ring/ring_y_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_null_1.png"//require('../images/spark/ring/ring_y_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_null_1.png"//require('../images/spark/ring/ring_y_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_null_1.png"//require('../images/spark/ring/ring_y_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_null_1.png"//require('../images/spark/ring/ring_y_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_null_1.png"//require('../images/spark/ring/ring_y_skip_null_1.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '0' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_0_null.png"//require('../images/spark/ring/ring_r_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_0_null.png"//require('../images/spark/ring/ring_r_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_0_null.png"//require('../images/spark/ring/ring_r_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_r_l_0_null.png"// require('../images/spark/ring/ring_r_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_0_null.png"//require('../images/spark/ring/ring_r_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName ="ring_r_o_0_null.png"// require('../images/spark/ring/ring_r_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_0_null.png"//require('../images/spark/ring/ring_r_skip_0_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_0_null.png"//require('../images/spark/ring/ring_g_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_0_null.png"//require('../images/spark/ring/ring_g_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName ="ring_g_c_0_null.png"// require('../images/spark/ring/ring_g_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_g_l_0_null.png"// require('../images/spark/ring/ring_g_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName ="ring_g_i_0_null.png"// require('../images/spark/ring/ring_g_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName ="ring_g_o_0_null.png"// require('../images/spark/ring/ring_g_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_0_null.png"//require('../images/spark/ring/ring_g_skip_0_null.png');
                        }else{
                            imageName ="no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName ="ring_y_e_0_null.png"//require('../images/spark/ring/ring_y_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_0_null.png"//require('../images/spark/ring/ring_y_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_0_null.png"//require('../images/spark/ring/ring_y_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_y_l_0_null.png"// require('../images/spark/ring/ring_y_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_0_null.png"//require('../images/spark/ring/ring_y_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_0_null.png"//require('../images/spark/ring/ring_y_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_0_null.png"//require('../images/spark/ring/ring_y_skip_0_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '1' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_1_null.png"//require('../images/spark/ring/ring_r_e_1_null.png');
                        }else if(skill === 's'){
                            imageName ="ring_r_s_1_null.png"// require('../images/spark/ring/ring_r_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName ="ring_r_c_1_null.png"// require('../images/spark/ring/ring_r_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_r_l_1_null.png"// require('../images/spark/ring/ring_r_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName ="ring_r_i_1_null.png"// require('../images/spark/ring/ring_r_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_1_null.png"//require('../images/spark/ring/ring_r_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_1_null.png"//require('../images/spark/ring/ring_r_skip_1_null.png');
                        }else{
                            imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_1_null.png"//require('../images/spark/ring/ring_g_e_1_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_1_null.png"//require('../images/spark/ring/ring_g_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_1_null.png"//require('../images/spark/ring/ring_g_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_1_null.png"//require('../images/spark/ring/ring_g_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_1_null.png"//require('../images/spark/ring/ring_g_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_1_null.png"//require('../images/spark/ring/ring_g_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_1_null.png"//require('../images/spark/ring/ring_g_skip_1_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_1_null.png"//require('../images/spark/ring/ring_y_e_1_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_1_null.png"//require('../images/spark/ring/ring_y_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_1_null.png"//require('../images/spark/ring/ring_y_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_1_null.png"//require('../images/spark/ring/ring_y_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_1_null.png"//require('../images/spark/ring/ring_y_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_1_null.png"//require('../images/spark/ring/ring_y_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName ="ring_y_skip_1_null.png"// require('../images/spark/ring/ring_y_skip_1_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }
            }else{
                if(movement === '' && sleep === '') {
                    if(skill === "") {
                        imageName = "ring_skip_0_null_null.png"// require('../images/spark/ring/ring_skip_0_null_null.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_null.png"// require('../images/spark/ring/ring_skip_skip_null_null.png');
                    }else{
                        imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '0' && sleep === '0') {
                    if(skill === "") {
                        imageName = "ring_skip_0_0_0.png"//require('../images/spark/ring/ring_skip_0_0_0.png');
                    }else if(skill === "skip") {
                        imageName =  "ring_skip_skip_0_0.png"//require('../images/spark/ring/ring_skip_skip_0_0.png');
                    }else{
                        imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if (movement === '1' && sleep === '1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_1.png"//require('../images/spark/ring/ring_skip_0_1_1.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_1_1.png"//require('../images/spark/ring/ring_skip_skip_1_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if (movement === '0' && sleep === '1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_0_1.png"//require('../images/spark/ring/ring_skip_0_0_1.png');
                    }else if(skill === "skip") {
                        imageName ="ring_skip_skip_0_1.png"// require('../images/spark/ring/ring_skip_skip_0_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if (movement === '1' && sleep === '0') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_0.png"//require('../images/spark/ring/ring_skip_0_1_0.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_1_0.png"//require('../images/spark/ring/ring_skip_skip_1_0.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if(movement === '' && sleep === '0') { 
                    if(skill === "") {
                        imageName = "ring_skip_0_null_0.png"//require('../images/spark/ring/ring_skip_0_null_0.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_0.png"//require('../images/spark/ring/ring_skip_skip_null_0.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }     
                }else if(movement === '' && sleep ==='1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_null_1.png"//require('../images/spark/ring/ring_skip_0_null_1.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_1.png"//require('../images/spark/ring/ring_skip_skip_null_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '0' && sleep === '') {
                    if(skill === "") {
                        imageName =  "ring_skip_0_0_null.png"//require('../images/spark/ring/ring_skip_0_0_null.png');
                    }else if(skill === "skip") {
                        imageName =  "ring_skip_skip_0_null.png"//require('../images/spark/ring/ring_skip_skip_0_null.png');
                    }else{
                        imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '1' && sleep === '') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_null.png"//require('../images/spark/ring/ring_skip_0_1_null.png');
                    }else if(skill === "skip") {
                        imageName ="ring_skip_skip_1_null.png"// require('../images/spark/ring/ring_skip_skip_1_null.png');
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else{
                    imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                }
            }

            return imageName;
    },
     async getDailyData360({ commit, dispatch, rootState, state ,getters}: any,value:any){
        //console.log('value=======>',value)
        value.num_month='09'
        const lastDayOfMonts=format(endOfMonth(new Date(value.year+"-"+value.num_month)), 'YYYY-MM-DD')
        let datefirstday=format(subWeeks(new Date(lastDayOfMonts), 51), 'YYYY-MM-DD')
        let lastDate = format(new Date(`${lastDayOfMonts}`), "dd");
        let status_feeling={good: 0,okay: 0,critical: 0}
        const firstdayQuarter=format(new Date(value.year+"-"+'07'), "YYYY-MM-01")
        
       

        if(lastDate=="Su"||lastDate=="Sa"){
            datefirstday=format(subWeeks(new Date(lastDayOfMonts), 52), 'YYYY-MM-DD')
        }
        
        let firstday = format(new Date(`${datefirstday}`), "dd");
        if(firstday!=="Su"&&firstday!=="Sa"&&firstday!=="Mo"){
            datefirstday=format(startOfISOWeek(new Date(`${datefirstday}`)), 'YYYY-MM-DD')
        }else{
            if(firstday=="Su"){
                datefirstday=format(addDays(new Date(datefirstday), 1), 'YYYY-MM-DD')

            }else if(firstday=="Sa"){
                datefirstday=format(addDays(new Date(datefirstday), 2), 'YYYY-MM-DD')
            }
        }
        let holiday:Array<any>=[]
        let pastmonth:Array<any>=[]
        for(let i=0;i<12;i++){
            const month =format(addMonths(new Date(datefirstday), i), 'M')
            pastmonth.push(month)
        }
        //console.log('pastmonth',pastmonth)
        state.month=pastmonth
        firebase.firestore().collection('/holliday').where('companyid','==',value.company).where('date','>=',`${datefirstday}-01`).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                holiday.push(data)        
            })
        })
       
        const answer={0:'very-happy',1:'pretty-good',2:'just-okay',3:'not-great',4:'terrible'}
        const _data:any={}



        const allResults:any = [];
        const teamData:any = [];
        const emailKey=value.email.replace(/\./g, '||')
        const users:any = (await firebase.database().ref(`/users/${emailKey}`).once('value')).val()

        const snapshot = await firebase.firestore()
        .collection('insight_teams')
        .where('team','==',users.team)
        .where('date', '>=', `${datefirstday}`)
        .get();
        snapshot.forEach((doc) => {

          if(!teamData[doc.data().date]){
            if(doc.data().color=='green'){
                teamData[doc.data().date]='pretty-good'
            }else if(doc.data().color=='yellow'){
                teamData[doc.data().date]='just-okay'
            }else if(doc.data().color=='red'){
                teamData[doc.data().date]='not-great'
            }
            
          }
          
        });



        






        firebase.firestore().collection('users_questions').where('users', 'in', [value.email]).where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where('date', '>=', `${datefirstday}`).get().then( async (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              if(data.answer||data.answer==0){
                if(!_data[data.date]){
                    _data[data.date]=[]
                }
                _data[data.date]=answer[data.answer]
              }
              
            })
     
            const _daily={}
            const _teamDaily={}
            let week=0
            let total=0
            let _dailyanswer=0
            for(let i=0;i<364;i++){

                const date =format(addDays(new Date(`${datefirstday}`), i), 'YYYY-MM-DD')
                let weekend = format(date, "dd");
                const _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                });
              
                if(weekend=="Mo"){
                    week++
                    if(!_daily[week]){
                        _daily[week]=[]
                    }
                    if(!_teamDaily[week]){
                        _teamDaily[week]=[]
                    }
                   // console.log('week',week)
                }
                
                if(weekend!=="Su"&&weekend!=="Sa"&&state.alldays==false){
                    if(!_daily[week]){
                        _daily[week]=[]
                    }
                    if(!_teamDaily[week]){
                        _teamDaily[week]=[]
                    }

                    if(date<=state.companyCreatedate){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                    }else
                    if(_holiday){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                        //consistent.push('holiday')
                    }else if(new Date(date)>new Date(lastDayOfMonts)){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                    }else{
                        if(_data[date]){
                            _dailyanswer++
                            total++
                            _daily[week].push(_data[date])
                            _teamDaily[week].push(teamData[date])
                            
                            if(format(new Date(date),'YYYY-MM-DD')>=format(new Date(firstdayQuarter),'YYYY-MM-DD')){
                              
                                if(teamData[date]){
                                   
                                    if(teamData[date]=='pretty-good'){
                                        status_feeling.good++
                                    }else if(teamData[date]=='just-okay'){
                                        status_feeling.okay++
                                    }else {
                                        status_feeling.critical++
                                    }
    
                                }

                            }
                           
                            //consistent.push(_data[date])
                        }else{
                            total++
                            _daily[week].push('skip')
                            _teamDaily[week].push('skip')
                            //consistent.push('skip')
                        }
                    }

                }else if(state.alldays==true){
                    if(!_daily[week]){
                        _daily[week]=[]
                    }
                    if(!_teamDaily[week]){
                        _teamDaily[week]=[]
                    }
                    if(date<=state.companyCreatedate){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                    }else
                    if(_holiday){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                        //consistent.push('holiday')
                    }else if(new Date(date)>new Date(lastDayOfMonts)){
                        _daily[week].push('holiday')
                        _teamDaily[week].push('holiday')
                    }else{
                        if(_data[date]){
                            _dailyanswer++
                            total++
                            _daily[week].push(_data[date])
                            _teamDaily[week].push(teamData[date])
                            
                            if(format(new Date(date),'YYYY-MM-DD')>=firstdayQuarter){
                           
                                if(teamData[date]){
                                    if(teamData[date]=='pretty-good'){
                                        status_feeling.good++
                                    }else if(teamData[date]=='just-okay'){
                                        status_feeling.okay++
                                    }else {
                                        status_feeling.critical++
                                    }
    
                                }

                            }
                            //consistent.push(_data[date])
                        }else{
                            total++

                            _daily[week].push('skip')
                            _teamDaily[week].push('skip')
                            //consistent.push('skip')
                        }
                    }

                }
                
               
                
            }
            commit('setConsistent',isNaN(Math.round((_dailyanswer/total)*100)) ? 0 : Math.round((_dailyanswer/total)*100))
            commit('setdailyData',_daily)
            commit('setteamDailyData',_teamDaily)
           
            commit('setFeeling', status_feeling)
        })
    }
   
   
    

  },
  getters: {
    engagement: (state: any) => {
      return state.engagement
    },
    current_dailyCheck: (state: any) => {
      return state.current_dailyCheck
    },
    directReports: (state: any) => {
      return state.directReports
    },
    directReportsData: (state: any) => {
      return {
        engagedValue: state.directReportsEngagedValue,
        engagedData: state.directReportsEngagedData
      }
    },
    directReportsLoading: (state: any) => {
      return state.directReportsLoading
    },
    loading: (state: any) => {
      return state.loading
    },
    userDetail:(state: any) => {
        return state.userDetail
      },
      contributions: (state: any) => {
        return state.dailyContributions
      },
      youFeeling: (state: any) => {
        return state.youFeeling
      },
      teamFeeling: (state: any) => {
        return state.teamFeeling
      },
      feeling: (state: any) => {
        return state.feeling
      },
      performingData: (state: any) => {
        return state.performingData
      },
      userCardData: (state: any) => {
        return state.userCardData
      },
      loadingStatus: (state: any) => {
        return state.loadingStatus
      },
      growingData: (state: any) => {
        return state.growingData
      },
      directReportsCardData: (state: any) => {

        return state.directReportsCardData
      },
      // Segmented talent views for new dashboard
      promotionTrack: (state: any) => {
        return state.directReportsCardData.filter((employee: any) => {
          const impactRating = parseFloat(employee.impact_rating) || 0;
          const isHighPerformer = impactRating >= 70;
          const isTopTalent = [
            'Superstar', 'High Performer', 'Distinguished Talent',
            'Respected Expert', 'Solid Performer'
          ].includes(employee.talent);
          const isHighlyEngaged = employee.engagedType === 'highlyEngaged' || employee.engagedType === 'moderatelyEngaged';

          // Strong performers with good engagement
          return isHighPerformer && (isTopTalent || isHighlyEngaged);
        }).sort((a: any, b: any) => parseFloat(b.impact_rating) - parseFloat(a.impact_rating));
      },
      developmentTrack: (state: any) => {
        return state.directReportsCardData.filter((employee: any) => {
          const impactRating = parseFloat(employee.impact_rating) || 0;
          const impactChange = parseFloat(employee.impact_rating_change) || 0;
          const isLowPerformer = impactRating < 40;
          const isDeclining = impactChange < -5;
          const isDisengaged = employee.engagedType === 'underEngaged' || employee.engagedType === 'inActive';

          // Low performers or declining employees
          return isLowPerformer || (isDeclining && impactRating < 60) || isDisengaged;
        }).sort((a: any, b: any) => parseFloat(a.impact_rating) - parseFloat(b.impact_rating));
      },
      hiddenGems: (state: any) => {
        return state.directReportsCardData.filter((employee: any) => {
          const impactRating = parseFloat(employee.impact_rating) || 0;
          const isGoodPerformer = impactRating >= 60 && impactRating < 70;
          const isLowVisibility = ['Low Network', 'Medium Network', 'Medium Inner', 'Medium Outer'].includes(employee.network_type);
          const isHiddenTalent = [
            'Hidden Gem', 'Unsung Talent', 'Emerging Talent',
            'Untapped Potential', 'High Potential'
          ].includes(employee.talent);

          // Good performers with low visibility
          return (isGoodPerformer && isLowVisibility) || isHiddenTalent;
        }).sort((a: any, b: any) => parseFloat(b.impact_rating) - parseFloat(a.impact_rating));
      },
      atRiskHighPerformers: (state: any) => {
        return state.directReportsCardData.filter((employee: any) => {
          const impactRating = parseFloat(employee.impact_rating) || 0;
          const impactChange = parseFloat(employee.impact_rating_change) || 0;
          const isHighPerformer = impactRating >= 60;
          const isSignificantDecline = impactChange < -8;
          const wasHighlyEngaged = employee.engagedType === 'somewhatEngaged' || employee.engagedType === 'underEngaged';
          const isTopTalent = [
            'Superstar', 'High Performer', 'Core Player', 'Key Player',
            'Solid Performer', 'Activated'
          ].includes(employee.talent);

          // High performers showing warning signs
          return isHighPerformer && isTopTalent && (isSignificantDecline || wasHighlyEngaged);
        }).sort((a: any, b: any) => parseFloat(a.impact_rating_change) - parseFloat(b.impact_rating_change));
      },
      talentSummary: (state: any, getters: any) => {
        return {
          promotionReady: getters.promotionTrack.length,
          developmentNeeded: getters.developmentTrack.length,
          hiddenGems: getters.hiddenGems.length,
          atRisk: getters.atRiskHighPerformers.length,
          total: state.directReportsCardData.length
        };
      },
      loadingProgress: (state: any) => {

        return state.loadingProgress
      },
      dailyData: (state: any) => {
        return state.dailyData
      },
      teamDailyData: (state: any) => {
        return state.teamDailyData || []
      },
      alldays: (state: any) => {
        return state.alldays
      },
      month: (state: any) => {
        return state.month
    },
    consistent :(state: any) => {
        return state.consistent
    },
}
}
